export const ApplicationString = {
  //adminPanel
  'eventScheduleAdd.button.add': 'スケジュール追加',
  'stemComponent.button.add': 'Stem追加',
  'eventTemplateScheduler.button.addForm': '新しいスケジュールを追加',
  'CommitteeMemberComponent.button.addForm': '委員会メンバーを追加',
  'signup.button.register': '登録する',
  'common.button.clearFeeForm': 'クリア',
  'common.button.submitForm': '提出する',
  'common.button.updateForm': '更新',
  'common.button.backToEvents': 'イベント一覧に戻る',
  'common.button.editAction': '編集',
  'common.button.deleteAction': '消去',
  'common.button.statusAction': '状態',
  'adFeesComponent.button.addForm': '新しい広告料金を追加',
  'jobFeesComponent.button.addForm': '新しい求人料金を追加',
  'jobsComponent.button.addForm': '新しい求人を追加',
  'speakersComponent.button.addForm': '新しいスピーカーを追加',
  'adsComponent.button.addForm': '新しい広告を追加',
  'adsApprovedListComponent.button': '広告を掲載するにはこちらをクリック​',
  'jobsApprovedListComponent.button': 'こちらをクリックして求人を投稿',
  'chaptersComponent.button.addForm': '新しいチャプターを追加',
  'emailCodesComponent.button.addForm': '新しいメールテンプレートを追加',
  'keywordsComponent.button.addForm': '新しい興味分野を追加',
  'eventTypesComponent.button.addForm': '新しいイベントタイプを追加',
  'companiesComponent.button.addForm': '新しい企業を追加',
  'couponCodesComponent.button.addForm': '新しいクーポンコードを追加',
  'sponsorsComponent.button.addForm': '新しいスポンサーを追加',
  'usersComponent.button.addForm': '新しいメンバー参加者を追加',
  'usersComponent.updateWillReceiveModalTitle': 'メール配信設定の更新',
  'eventOptionGroupsComponent.button.addForm':
    '新しいイベントオプショングループを追加',
  'eventOptionsComponent.button.addForm': '新しいイベントオプションを追加',
  'eventsComponent.button.addForm': '新しいイベントを追加',
  'pbssFilesComponent.button.addPbssFiles': '新しいPBSSファイルを追加',

  //Add Note Modal
  'addNoteModal.placeholder': 'ノートを入力してください...',
  'addNoteModal.description':
    'このイベント登録に関する追加情報やコメントを提供してください。',
  'addNoteModal.eventRegistrationId': 'イベント登録ID',
  'addNoteModal.addNote': 'ノートを追加',
  'addNoteModal.cancel': 'キャンセル',

  //Special Payment
  'specialPayment.button.addForm': '特別支払いを生成',
  'adminSpecialPayment.button.submit': '提出する',
  'adminSpecialPayment.button.reset': 'リセット',
  'specialPayment.alertMessage': 'お支払いありがとうございます',
  'dynamicSearch.button.update': '更新',
  'dynamicSearch.button.search': '検索',
  'dynamicSearch.button.reset': 'リセット',
  'dynamicSearch.button.submit-your-feedback': 'フィードバックを送信',
  'dynamicSearch.button.heading': 'フィルター検索',
  'common.button.backForm': 'キャンセル',
  'adminEvents.button.resetToLastSaved': '最後に保存した内容に戻す',
  'adminEvents.button.resetToLastSaved.tooltip':
    '未保存の変更を破棄し、最後に保存したイベント内容に戻します。このページに留まります。',
  'couponCodesFormComponent.button.addFormHeading': 'クーポンコード詳細を追加',
  'couponCodesFormComponent.button.editFormHeading': 'クーポンコード詳細を編集',
  'speakersFormComponent.button.addFormHeading': 'スピーカー詳細を追加',
  'speakersFormComponent.button.editFormHeading': 'スピーカー詳細を編集',
  'jobFeesFormComponent.button.addFormHeading': '求人料金詳細を追加',
  'jobFeesFormComponent.button.editFormHeading': '求人料金詳細を編集',
  'adFeesFormComponent.button.addFormHeading': '広告料金詳細を追加',
  'adFeesFormComponent.button.editFormHeading': '広告料金詳細を編集',
  'jobsFormComponent.button.addFormHeading': '求人詳細を追加',
  'jobsFormComponent.button.editFormHeading': '求人詳細を編集',
  'companiesFormComponent.button.addFormHeading': '企業詳細を追加',
  'companiesFormComponent.button.editFormHeading': '企業詳細を編集',
  'eventOptionGroupsFormComponent.button.addFormHeading':
    'イベントオプショングループ詳細を追加',
  'eventOptionsFormComponent.button.editFormHeading':
    'イベントオプショングループ詳細を編集',
  'eventOptionsFormComponent.button.addFormHeading':
    'イベントオプション詳細を追加',
  'eventOptionsFormComponent.button.editFormHeading':
    'イベントオプション詳細を編集',

  //userPanel
  'userJobsComponent.cardHeading': 'PBSS.org 求人リンクサービス',
  'userJobsComponent.cardSubHeading': '世界中の求人情報',
  'userJobsComponent.contentHeading':
    'Our jobs link service posts jobs relevant to the pharmaceutical and bioscience industry. The jobs are also delivered to the 4000+ members through our newsletters.',
  'userComponent.button.addListing': 'Add New',
  'userComponent.button.addListing.approvedAds': 'Add New Ad',
  'userComponent.button.addListing.approvedJobs': 'Add New Job',
  'userAdsComponent.cardHeading': 'PBSS.org 広告掲載サービス',
  'userAdsComponent.cardSubHeading': '世界中の求人情報',
  'userResetPasswordComponent.heading': 'パスワードリセット',
  'userChangePasswordComponent.heading': 'パスワード変更',
  'userResetPasswordComponent.subheading':
    'パスワードを更新してください | イベントを登録するにはログインが必要です',
  'userChangePasswordComponent.subheading':
    'アカウントのセキュリティを強化するため、古いパスワードを入力の上、新しいパスワードを入力してください。',
  'userText.done': '完了',
  'userText.cancel': 'Cancel',
  'userText.save': 'Save',
  'userText.welcomeToPbss': 'PBSSへようこそ',
  'userText.welcomeToPbssDescription':
    'バイオテクノロジーや製薬業界などの多様な組織で働く皆様へ',
  'userText.LearnMore': '詳細を見る',

  //About Us
  'userAboutUsComponent.heading': 'Pharmaceutical & BioScience Society',
  'userAboutUsComponent.paragraph':
    '製薬・バイオサイエンス学会インターナショナルは、バイオテクノロジーや製薬業界、CRO、ライフサイエンス機器サプライヤー、学術機関、政府研究所など、ライフサイエンス分野の多様な組織で働く科学者やその他の専門職の非営利専門組織です。20,000名以上の参加者を有し、世界最大のライフサイエンスクラスターであるサンフランシスコベイエリア、サンディエゴ、ボストン、シアトル、バンクーバー、韓国の6つのメンバー組織を通じて活動しています。',
  'userAboutUsComponent.ourMission': '私たちの使命',
  'userAboutUsComponent.chapterSanFranciscoBay':
    'PBSS - サンフランシスコベイについて',
  'userAboutUsComponent.chapterSanFranciscoBayAbout':
    'サンフランシスコベイ製薬・バイオサイエンス学会について...',
  'userAboutUsComponent.ourMissionParagraph':
    'PBSSの使命は、科学的アイデアの交換を促進し、製薬・ライフサイエンス関連分野での成長機会を提供することです。セミナーランチョン、集中ワークショップ（短期コース）、シンポジウム、ウェビナー、キャリア開発プログラムを通じて、交流を促進し、情報を発信しています。',
  'userAboutUsComponent.standingCommittee': 'PBSSリーダーシップ',
  'userAboutUsComponent.standingCommittee.subText':
    'メンバー名をクリックして略歴をご覧ください',
  'userAboutUsComponent.standingCommittee.boston':
    'ボストンチャプター委員会メンバー',
  'userAboutUsComponent.standingCommittee.korea':
    '韓国チャプター委員会メンバー',
  'userAboutUsComponent.standingCommittee.sf-bay':
    'サンフランシスコベイチャプター委員会メンバー',
  'userAboutUsComponent.standingCommittee.san-diego':
    'サンディエゴチャプター委員会メンバー',
  'userAboutUsComponent.standingCommittee.vancouver':
    'バンクーバーチャプター委員会メンバー',
  'userAboutUsComponent.standingCommittee.advisors': '名誉顧問',
  'userAboutUsComponent.standingCommittee.operationTeam': '運営チーム',
  'userAboutUsComponent.standingCommittee.programManagement': 'プログラム管理',
  'userAboutUsComponent.standingCommitteeParagraph':
    'ロゴは、ベンダーまたは企業スポンサーのそれぞれのブランドのブランディング素材を表しています。',
  'userCommonAdsListingCard.button.checkItOut': 'チェックしてみる',
  'userCommonAdsListingCard.button.delete': 'Delete Ad',

  //sponsor details
  'userAddAttendeeComponent.sponsorDetail.label':
    'スポンサーの代表者連絡先情報',
  'userAddAttendeeComponent.sponsorDetail.description':
    '参加者詳細を入力する前に、スポンサー詳細セクションにご記入ください。連絡担当者が会議のプレゼンテーションに参加される場合は、次のセクションでその方の情報もご記入ください。',
  'userAddAttendeeComponent.sponsorDetail.perksLabel':
    'ワークショップ参加者登録',
  'userAddAttendeeComponent.sponsorDetail.perksLabel': 'スポンサー参加者登録',
  'userAddAttendeeComponent.sponsorDetail.perksDescription':
    '会議プレゼンテーション登録にはベンダーショー登録が含まれていますが、ベンダーショーのみの登録者は会議プレゼンテーションにアクセスできませんのでご注意ください。',
  'userAddAttendeeComponent.sponsorDetail.perksDescription.major':
    'メジャースポンサーは最大2席の無料ワークショップ席を利用できます。2席を超える場合は、追加料金をお支払いいただく必要があります。会議プレゼンテーション登録にはベンダーショー登録が含まれていますが、ベンダーショーのみの登録者は会議プレゼンテーションにアクセスできませんのでご注意ください。',

  // Add Attendee
  'userAddAttendeeComponent.regularAttendee.label': '参加者',
  'userAddAttendeeComponent.registerAs.sponsorText':
    'スポンサー登録はこちらをクリック',
  'userAddAttendeeComponent.registerAs.myEvents': '私のイベント',
  'userAddAttendeeComponent.regularAttendeeForSponsorAttendee.label':
    '通常スポンサー参加者',
  'userAddAttendeeComponent.regularAttendeeForVendorAttendee.label':
    '通常ベンダー参加者',
  'userAddAttendeeComponent.popup':
    'イベント開始日の14日前まで登録を変更できます。イベント開始14日以内の変更にはPBSSの承認が必要です。変更リクエストは、イベント開始4日前までにPBSSに提出する必要があります。',
  'userAddAttendeeComponent.popup1': 'イベント開始4日前まで。',
  'userAddAttendeeComponent.message':
    '登録に関してご質問や問題が発生した場合。',

  // Ads Cart
  'userAdsCartComponent.heading': '広告',
  'userAdsCartComponent.subheading':
    'イベントの価格、スケジュールなどの詳細をご確認ください。',

  // Ads Form
  'userAdsFormComponent.heading': 'Vendor Advertisement Form',
  'userAdsFormComponent.subheading':
    ' Our advertisement posts relevant to the pharmaceutical and bioscience industry.The ads are also delivered to the 4000+ members through our newsletters.',

  // Approved Ads Listing
  'userApprovedAdsListingComponent.heading': 'PBSS - Approved Ads',
  'userApprovedAdsListingComponent.subheading':
    'Our advertisements are relevant to the pharmaceutical and bioscience industry. The ads are also delivered to the 4000+ members through our newsletters.',

  // My Ads
  'userAdsComponent.contentHeading':
    'Our advertisement posts relevant to the pharmaceutical and bioscience industry.The ads are also delivered to the 4000+ members through our newsletters.',
  'userAdsComponent.heading': 'PBSS.org Ads Publish Service',
  'userAdsComponent.subheading': '広告を掲載する',

  // Assets Upload Component
  'userAssetsUploadComponent.uploadConditionText':
    '9x12インチ レターサイズ、3MB以下のPDF',
  'userAssetsUploadComponent.uploadLogoText': 'ロゴをアップロード',
  'userAssetsUploadComponent.1080px1080px': '1080px x 1080px',

  // Attendee Cart Component
  'userAttendeeCartComponent.button.goBacktoAddAttendeeText':
    '参加者追加に戻る',
  'userAttendeeCartComponent.confirm&PayText': '続行​',
  'userAttendeeCartComponent.afterPayment': '参加者を編集',
  'userAttendeeCartComponent.subHeading': 'カートの確認と詳細の確認',
  'userAttendeeCartComponent.subHeading.afterPayment': '参加者詳細の編集',
  'userAttendeeCartComponent.couponCodeTitle': 'クーポンコード',
  'userAttendeeCartComponent.couponCodeButtonText': '適用',
  'userAttendeeCartComponent.totalAmountToBePaid': 'お支払い合計金額',

  // Chapter Navigation Component
  'userChapterNavigationComponent.heading':
    'Pharmaceutical & BioScience Society Internationalへ',
  'userChapterNavigationComponent.subheading': 'ようこそ',
  'userChapterNavigationComponent.heading':
    'Pharmaceutical & BioScience Society Internationalへ',
  'userChapterNavigationComponent.subheading': 'ようこそ',

  // Contact Us Component
  'userContactUsComponent.heading': 'お問い合わせ',
  'userContactUsComponent.ThankyouText':
    'お問い合わせとフィードバックをお待ちしております！',
  'userContactUsComponent.description':
    '草の根組織として、私たちはメンバーからのアイデアや貢献によって発展しています。実際、私たちの会議のトピックやスピーカーの多くは、メンバーの提案から生まれています。PBSSに対するご提案、リクエスト、ご質問がございましたら、将来のトピックの可能性や会議の企画に関するご興味も含めて、以下のフォームでお問い合わせください。また、info@pbss.org までメールでお問い合わせいただくことも可能です。',
  'userContactUsComponent.captchaText': 'CAPTCHAを完了する',
  'userContactUsComponent.button.welcomeVolunteers':
    '私たちは常にボランティアを歓迎しています！',
  // Contact Us Form Placeholder
  'userContactUsFormComponent.name.validationMessage': 'お名前をご記入ください',
  'userContactUsFormComponent.state.placeholder': '州/県を入力',
  'userContactUsFormComponent.email.validationMessage':
    'メールアドレスを入力してください',
  'userContactUsFormComponent.emailConfirm.validationMessage':
    'メールアドレスを入力してください',
  'userContactUsFormComponent.inquiry.validationMessage':
    'お問い合わせの件名をご記入ください',
  'userContactUsFormComponent.description.validationMessage':
    '詳細を入力してください',
  'userContactUsFormComponent.name.placeholder': 'フルネームを入力してください',
  'userContactUsFormComponent.email.placeholder': 'メールアドレスを入力',
  'userContactUsFormComponent.emailConfirm.placeholder': 'Eメール確認',
  'userContactUsFormComponent.inquiry.placeholder':
    'お問い合わせのトピックまたはタイトルを入力してください',
  'userContactUsFormComponent.selectCity.placeholder': '都市名を入力',
  'userContactUsFormComponent.selectCountry.placeholder':
    '国を入力してください',
  'userContactUsFormComponent.phoneNumber.placeholder':
    '電話番号を入力してください',
  'userContactUsFormComponent.selectAffiliation.placeholder': '所属を選択',
  'userContactUsFormComponent.selectEmailSubject.placeholder':
    'メールの件名を選択',
  'userContactUsFormComponent.description.placeholder':
    'コメントや説明を追加する',
  'userContactUsFormComponent.captcha.validationMessage':
    '上記のCAPTCHAをクリックしてください',
  // Event Sponsor Component
  'userEventSponsorComponent.subheading': 'スポンサー登録のオプションを選択',
  'userEventSponsorComponent.registerAs.regularAttendeeText':
    '参加者として登録する',
  'userEventSponsorComponent.registerAs.myEvents': '私のイベント',
  'userEventSponsorComponent.deleteText': '出席者',
  'userEventSponsorComponent.backtoSponsorOption':
    'スポンサーシップオプションに戻る',
  'userEventSponsorComponent.ProceedToPay': '続行',

  //test heading
  'testHeading.heading':
    'ロレム・イプサム・ドロール・シット・アメット、コンセクテトゥール・アディピスシング・エリット。セド・ノン・リスス。サスペンディッセ・レクトゥス・トルトル、ディグニッシム・シット・アメット、アディピスシング・ネク、ウルトリシエス・セド、ドロール。クラス・エレメントゥム・ウルトリシエス・ディアム。マエケナス・リグラ・マッサ、ウァリウス・ア、センペル・コングエ、エウィスモド・ノン、ミ。プロイン・ポルティトル、オルシ・ネク・ノヌミー・モレスティエ、エニム・エスト・エレイフェンド・ミ、ノン・フェルメントゥム・ディアム・ニスル・シット・アメット・エラット。ドゥイス・センペル。ドゥイス・アルク・マッサ、スケレリスク・ウィタエ、コンセクワット・イン、プレティウム・ア、エニム。ペレンテスク・コングエ。ウット・イン・リスス・ウォルトパット・リベロ・ファレトラ・テンポル。',

  // Event Sponsor Cart
  'userEventSponsorCartComponent.backToSponsorship': 'スポンサーシップに戻る',
  'paymentCheckoutComponent.backToAddVendorReps': 'ベンダー担当者の追加に戻る',

  // Event Details modal
  'userEventDetailsModal.alertMsg.expired':
    'このイベントの払い戻し期限は過ぎています。詳細については、管理者にお問い合わせください。',

  // Approved Jobs
  'userApprovedJobsListingComponent.heading':
    'Life Science Jobs Submitted by Employers',
  'userApprovedJobsListingComponent.subtitle':
    'バイオテクノロジーおよび製薬業界の多様な組織での働く機会',
  'userApprovedJobsListingComponent.subheading':
    'The jobs listings are also delivered to our members through our newsletters.',
  'userApprovedJobsListingComponent.button.viewDetails': 'View Details',
  'userApprovedJobsListingComponent.button.edit': 'Edit Job',
  'userApprovedJobsListingComponent.button.delete': 'Delete Job',
  'stemOutreachComponent.title': 'STEM普及活動',
  'industryOutreachComponent.title': '業界',
  'userApprovedJobsListingComponent.button.pay': 'Pay',

  // Jobs
  'userJobsComponent.button.viewMore': 'View More Jobs',
  'userJobsComponent.button.viewMoreJobs': '他の求人を見る',
  'userJobsComponent.searchForJobsText': 'Search for jobs',
  'userJobsComponent.locationText': '勤務地',
  'userJobsComponent.statusPlaceHolder': 'Status',
  'userJobsComponent.heading': '新しい求人リストを追加',
  'userJobsComponent.subheading.part1':
    '当社の求人リンクサービスでは、製薬・バイオサイエンス業界に関連する求人を掲載しています。これらの求人は、4000名以上の',
  'userJobsComponent.subheading.part2':
    'メンバーにニュースレターを通じて配信されます。',
  'userJobsComponent.uploadLogoText': 'ロゴをアップロード',
  'userJobsComponent.paymentText':
    'まず、掲載プロセスを進めるために支払いを完了してください。',
  'userJobsComponent.submit&CheckoutText': '進行して確認',

  // Jobs View Details Component
  'userJobViewDetailsComponent.heading': '求人詳細',
  'userJobViewDetailsComponent.subheading': '世界中の求人詳細',
  'userJobViewDetailsComponent.button.applyNow': 'Apply Now',
  'userJobViewDetailsComponent.qualify&skillReq':
    'Qualifications & Skills Required',
  'userJobViewDetailsComponent.jobDescriptionText': '説明：',
  'userJobViewDetailsComponent.jobPositionText': 'ポジション：',
  'userJobViewDetailsComponent.newHeading': '求人情報',

  //sponsor perks
  'userEventSponsorComponent.sponsorPerks.uploadLogo':
    '企業/スポンサーロゴをアップロード',
  'userEventSponsorComponent.sponsorPerks.editUploadLogo':
    '企業/スポンサーロゴをアップロード',
  'userEventSponsorComponent.sponsorPerks.eventSponsorButton': '登録​',
  'userEventSponsorComponent.sponsorPerks.addWaitingListButton':
    '待機リストに参加する',
  'userEventSponsorComponent.sponsorPerks.eventContinueSponsorButton':
    '登録を続ける',
  'userEventSponsorComponent.sponsorPerks.removeFromCart': 'カートから削除',

  // UserJobsComponent
  'userJobsComponentPage.heading': 'Job Postings',
  'userJobsComponentPage.subheading': '世界中の求人情報',

  // Login
  'userLoginComponent.heading': 'ログイン',
  'userLoginComponent.subheading':
    'アカウントにログインしてください | イベント登録にはログインが必要です',
  'userLoginComponent.addNote':
    '転職によるログインの問題を回避するために、ログイン後にアカウントのメール アドレスを永続的な個人用メール アドレスに変更することを強くお勧めします（まだ変更していない場合）。',

  // Reset Password
  'userResetPasswordComponent.heading': 'パスワードをリセットする​',
  'userResetPasswordComponent.subheading':
    'パスワードを更新してください | イベントを登録するにはログインが必要です',

  // My Events
  'userMyEventsComponent.heading': 'PBSS - 私のイベント',
  'userMyEventsComponent.subheading':
    '登録した今後のイベントのステータスを確認してください。',
  'userLoginComponent.validationTermsandConditions':
    '利用規約に同意する必要があります。',
  'userMyEventsComponent.button.registerForNewEvents':
    '新しいイベントに登録する',
  'userMyEventsComponent.cancellationPolicy': 'キャンセルポリシー',
  'userMyEventsComponent.cancellationPolicy.title1': '会議参加者の皆様：',
  'userMyEventsComponent.cancellationPolicy.content1':
    '参加者からの返金リクエストは、イベント開始日の少なくとも3営業日前までにウェブサイトからご提出ください。返金はクレジットカード手数料を差し引いた全額を返金いたします。返金期限を過ぎた場合は、参加費は返金できません',

  'userMyEventsComponent.cancellationPolicy.title2': '主要スポンサーシップ：',
  'userMyEventsComponent.cancellationPolicy.content2':
    'スポンサーイベント開催日の2ヶ月前までは、500ドルのペナルティを差し引いた金額を返金いたします。返金期限を過ぎた場合は、スポンサーシップ料金は返金不可となります。',

  'userMyEventsComponent.cancellationPolicy.title3': 'ランチスポンサーシップ：',
  'userMyEventsComponent.cancellationPolicy.content3':
    'スポンサーイベント開催日の2ヶ月前までは、300ドルのペナルティを差し引いた金額を返金いたします。返金期限を過ぎた場合は、スポンサーシップ料金は返金いたしかねます。',

  'userMyEventsComponent.cancellationPolicy.title4':
    'ハッピーアワースポンサーシップ：',
  'userMyEventsComponent.cancellationPolicy.content4':
    'スポンサーイベント開催日の2ヶ月前までは、300ドルのペナルティを差し引いた金額を返金いたします。返金期限を過ぎた場合は、スポンサーシップ料金は返金いたしかねます。',

  'userMyEventsComponent.cancellationPolicy.title5': 'ベンダーショー：',
  'userMyEventsComponent.cancellationPolicy.content5':
    'スポンサーイベント開催日の2週間前までは、100ドルのペナルティを差し引いた金額を返金いたします。返金期限を過ぎた場合は、スポンサー料は返金いたしかねます',
  'userMyEventsComponent.cancellationPolicy.content6':
    '払い戻しのご請求は、いつ行われたかに関わらず、クレジットカード決済手数料が差し引かれます。払い戻しのご請求は、アカウントにログイン後、「マイイベント」ページからオンラインで行ってください。私たちはボランティアによって運営されている団体であり、ボランティアの方々がこのような問題に対応する際の負担を最小限に抑える必要があるため、このポリシーをご理解いただければ幸いです。ポリシーは支部によって異なる場合がありますのでご了承ください。ご質問は<a href="mailto:info@pbss.org">info@pbss.org</a>までお問い合わせください。',

  // My Events CART
  'userMyEventsCartComponent.heading': 'PBSS - マイカート',
  'userMyEventsCartComponent.subheading':
    '登録した今後の有料イベントの注文状況。​',
  'userMyEventsCartComponent.totalAmount': 'お支払い合計金額',
  'userMyEventsCartComponent.paymentHint':
    '以下の各イベントの支払いを完了してください。「支払い完了」をクリックしてチェックアウトに進みます。',
  'myEventCard.payInCart': 'カートで支払う',

  // PBSS Chapter Component
  'userPbssChapterComponent.heading':
    'Pharmaceutical & BioScience Societyへようこそ',

  // Workshop Agenda
  'userWorkShopAgendaComponent.heading.Bio': 'イベントの説明',
  'userWorkShopAgendaComponent.heading.Info': 'イベントアジェンダ',
  'userWorkShopAgendaComponent.heading.Speaker': '講演者の略歴',
  'userWorkShopAgendaComponent.subheading':
    '臨床薬理学は、研究開発製品のライフサイクル管理全体を通じて、適切な標的、適切な用量、適切な集団の確立において重要な役割を担う、医薬品開発の不可欠な要素です。',

  // Event Form Admin Leave Popup
  'userEventFormAdminLeavePopupComponent.heading': 'ページを離れますか？',
  'userEventFormAdminLeavePopupComponent.subheading':
    '行った変更は失われます。同じページに留まるには「編集を続ける」ボタンをクリックし、ページを離れるには「終了」をクリックしてください。',
  'userEventFormAdminLeavePopupComponent.button.continueEditing':
    '編集を続ける',
  'userEventFormAdminLeavePopupComponent.button.exit': '終了',

  //STEM Highlights
  'userStemHighlightsComponent.mainTitleText': 'STEMハイライト',

  // Industry Highlights
  'userIndustryHighlightsComponent.mainTitleText': '業界ハイライト',

  //CAREER Mentorship Highlights
  'userCareerMentorshipHighlightsComponent.mainTitleText':
    'キャリアメンターシップハイライト',

  // Event Info Card
  'userEventInfoCardComponent.mainTitleText': 'イベントハイライト',
  'userEventInfoCardComponent.props.date': '9月12日 | 火曜日',
  'userEventInfoCardComponent.props.eventName': '臨床薬理学イベント | 2023',
  'userEventInfoCardComponent.props.description':
    '臨床薬理学は薬物開発の不可欠な要素です...',
  'userEventInfoCardComponent.props.location': 'SF-ベイでの会議',

  'userEventInfoCardComponent.card.title-image1':
    '薬物開発の連続体における臨床薬理学 | 2022',
  'userEventInfoCardComponent.card.date-image1': '9月06日 | 火曜日',
  'userEventInfoCardComponent.card.description-image1':
    '臨床薬理学は、治験薬の開発およびライフサイクル管理全体を通じて適切な標的、適切な用量、適切な母集団を確立する上で重要な役割を果たす薬物開発の不可欠な要素です。このワークショップでは、初回ヒト投与量の確立から申請書類のパッケージインサート作成まで、薬物開発プロセス全体における主要な意思決定マイルストーンに臨床薬理学がどのように貢献するかの概要を提供します。臨床薬理学研究を実施するための基本原則と戦略、および薬物開発プロセスを加速するためのモデリングとシミュレーションアプローチについて説明します。実際の応用例により、臨床薬理学プログラムの開発と実行に対する現代的なアプローチを示します。このワークショップは、薬物開発初心者、この分野についてもっと学びたい他の専門分野の専門家、および知識を更新し新たなトピックについて議論したい臨床薬理学者に適しています。',
  'userEventInfoCardComponent.card.location-image1': 'サンディエゴでの会議',

  'userEventInfoCardComponent.card.title-image2':
    '飛躍への挑戦：バイオテック起業について知りたいすべて | 2023',
  'userEventInfoCardComponent.card.date-image2': '5月25日 | 木曜日',
  'userEventInfoCardComponent.card.description-image2':
    'バイオテックを起業するために何が必要なのか疑問に思ったことはありませんか？小規模なスタートアップやステルス企業への次のキャリア移動を計画し、利益/リスクを理解したいですか？または情熱的な起業家の考えを知りたいですか？この魅力的なトピックについてもっと学び、熟練した専門家から話を聞ける1時間のインタラクティブな「素晴らしさを育む」セッションにご参加ください。',
  'userEventInfoCardComponent.card.location-image2': '韓国での会議',

  'userEventInfoCardComponent.card.title-image3':
    'FDA プロジェクト・オプティマスを踏まえた腫瘍学臨床用量最適化 | 2024',
  'userEventInfoCardComponent.card.date-image3': '2月12日 | 月曜日',
  'userEventInfoCardComponent.card.description-image3':
    '歴史的に、腫瘍学における用量選択はMTDパラダイムによって推進されてきました。この従来のアプローチは、腫瘍学で利用可能な治療法が少なく、効果的な薬物を可能な限り迅速に市場に投入する必要があったことが一因でした。腫瘍学薬物開発の分野が成熟し、がん患者が慢性療法でこれまで以上に長く生存するようになった今、薬物開発者として、腫瘍学用量選択へのアプローチを新しいパラダイムに移行することで、これらの新しい課題に取り組む必要があります。この1日シンポジウムでは、腫瘍学用量選択に対する新しい規制上の期待、研究デザインおよび統計的観点から腫瘍学用量選択を最適化するさまざまなアプローチ、用量選択をサポートするさまざまな臨床薬理学的考慮事項と関連分析、および患者報告アウトカムを使用した評価について議論します。',
  'userEventInfoCardComponent.card.location-image3': 'PBSS SF-ベイでの会議',

  // Register
  'userRegisterComponent.heading': 'PBSSに参加する',
  'userRegisterComponent.subheading': ' ',
  'userRegisterComponent.companyName.placeholder':
    '会社／組織名、または N/A を入力してください',
  'userRegisterComponent.companyName.helpText':
    '現在、組織や機関に所属していない場合は N/A と入力してください。',
  'userRegisterComponent.description':
    'PBSSに参加するには、以下のフォームにご記入ください。',
  'userRegisterComponent.disclaimer':
    '会員のプライバシーを保護するため、会員情報は PBSS の運営のみに使用され、PBSS の外部には共有されません。',
  'userRegisterComponent.disclaimer2':
    'PBSSの会員になると、メールマガジンの配信に自動的に登録されます。配信停止をご希望の場合は、いつでも手続きが可能です。',

  // Sponsor Policy
  'userSponsorPolicyComponent.p1':
    'イベントの少なくとも1日前に、スライドを主催者にメールで送信する必要があります。あなたの持ち時間は10分のみであり、それに応じて計画する必要があることを念頭に置いてください。',
  'userSponsorPolicyComponent.p2':
    'ワークショップ/シンポジウム期間中、メジャースポンサーの2名の代表者に無料ランチが提供されます。セミナーランチョンの場合、ランチの数は無制限です。オンライン登録が必要です。',
  'userSponsorPolicyComponent.membershipListSharing':
    'メンバーシップリスト共有に関するポリシー：',
  'userSponsorPolicyComponent.membershipListSharing.description':
    'メンバーのプライバシーを保護するため、メンバーシップリストや会議出席者リストなどのメンバーシップ情報は、内部業務にのみ厳密に使用され、外部の当事者と共有することはできません。',
  'userSponsorPolicyComponent.vendorShowCard.title':
    '「非商業的」プレゼンテーションのベンダースピーカーに関するポリシー：',
  'userSponsorPolicyComponent.vendorShowCard.description': `科学会議の1つにスピーカーを提供するというベンダーからの要求をよく受けます。残念ながら、商業的宣伝やベンダー優遇の印象を避けるため、私たちのポリシーでは一般的にベンダースピーカーの使用を禁止しています。ただし、私たちが聞くことに興味のあるユニークな技術をベンダーが保有している稀なケースは除きます。1つの妥協案は、ベンダーがそのベンダーの技術の専門家であるクライアント科学者を推薦することです。`,
  'userSponsorPolicyComponent.vendorShowCard.title2':
    'ベンダーショーとワークショップに参加するベンダー代表者に関するポリシー：',
  'userSponsorPolicyComponent.vendorShowCard.li1': `各ベンダーショースポンサーは、ブース参加のために無制限の数の代表者を送ることができます（ただし、ワークショップ参加は含まれません）。追加の代表者がランチを必要とする場合、ランチはオンラインでいくつかの方法で購入できます：1）ベンダーショーに登録している代表者が、ベンダーショーの支払い時点または後でログインし直して追加の代表者を追加できます；2）追加の代表者が自分でログインしてランチを購入できます。`,
  'userSponsorPolicyComponent.vendorShowCard.li2': `ベンダーあたり1名の代表者が、ベンダーショー登録時に配布資料の費用のみでワークショップに登録できます。`,
  'userSponsorPolicyComponent.vendorShowCard.li3': `追加の代表者/従業員がワークショップに参加したい場合、通常の参加者として登録する必要があります（ワークショップ参加 + 配布資料 +/- ランチ）。この代表者がワークショップの料金を支払いたくない場合、スペースが許す限り登録なしで参加できます。ただし、その代表者は配布資料のコピーをオンラインまたは会場で別途購入することはできません。彼/彼女は、通常のウォークイン参加者のはるかに高い会場料金ではなく、通常のオンラインワークショップ料金（ワークショップ参加 + 配布資料 +/- ランチ）で会場で登録できます。`,
  'userSponsorPolicyComponent.vendorShowCard.li4': `メジャースポンサーは、2席の無料ワークショップ席 + 2部の配布資料 + 2食のランチを取得します；メジャースポンサーシップ支払い以外の別途登録は不要です。`,
  'userSponsorPolicyPage.title': 'スポンサーシップポリシー',
  'userSponsorPolicyPage.subtitle': 'スポンサーシップポリシーに関する情報',

  // Event Major Sponsor page
  'userEventMajorSponsorPage.heading': 'メジャースポンサーシップ',
  'userEventMajorSponsorPage.subheading':
    'イベント詳細から「スポンサーとして登録」ボタンをクリックしてスポンサーになることができます。',
  'userEventMajorSponsorPage.description':
    'セミナーランチョンまたはフルデイイベントの半日セッションでは、メジャースポンサーシップスロットを1つのみ許可しています。',
  'userEventMajorSponsorCard.heading': 'メジャースポンサーシップ',
  'userEventMajorSponsorCard.regularPriceText': '通常価格',
  'userEventMajorSponsorCard.benefitsText': '特典：',
  'userEventMajorSponsorCard.bodyText': `イベントまたはセッションの唯一のメジャースポンサーとして、以下を通じて大きな露出を得ることができます：`,
  'userEventMajorSponsorCard.li1': `参加者の席に製品パンフレットを配布`,
  'userEventMajorSponsorCard.li2': `基調セミナーの直前に10分間の演壇プレゼンテーション機会`,
  'userEventMajorSponsorCard.li3': `最も目立つ場所での6席の展示テーブル`,
  'userEventMajorSponsorCard.afterListText':
    'すべてのスポンサーシップ支払いは当社のウェブサイトを通じて行われる必要があります。発注書は発行しません。',
  'userEventMajorSponsorCard.buttonText.signupforsponsorship':
    'スポンサーシップに登録',
  'userEventMajorSponsorCard.buttonText.contactourvendorliaison':
    'ベンダー連絡係に連絡',
  'userEventMajorSponsorCard.buttonText.makeaspecialpayment':
    '特別支払いを行う',
  'userEventMajorSponsorCard.instructions.heading':
    'メジャースポンサーシップ指示：',
  'userEventMajorSponsorCard.instructions.l1':
    'イベントの少なくとも1日前に、スライドを主催者にメールで送信する必要があります。あなたの持ち時間は10分のみであり、それに応じて計画する必要があることを念頭に置いてください。',
  'userEventMajorSponsorCard.instructions.l2':
    'ワークショップ/シンポジウム期間中、メジャースポンサーの2名の代表者に無料ランチが提供されます。セミナーランチョンの場合、ランチの数は無制限です。オンライン登録が必要です。',

  // Sponsorship option
  'userSponsorshipOptionComponent.heading': 'スポンサーシップの種類を選択',
  'userSponsorshipOptionComponent.subheading': '',
  'userSponsorshipOption.alertMessage':
    'このイベントにはスポンサー枠がありません。参加者登録ページに戻り、一般参加者として登録してください。',
  'userNormalAttendee.alertMessage':
    'スポンサーシップの登録受付を開始しました。上のボタンをクリックしてお進みください。一般登録枠もまもなく開始されますので、このページをご確認ください。',
  'userRegistrationOption.alertMessage':
    'スポンサー登録が開始されました。上のボタンをクリックして続行してください。一般登録の枠もまもなく開始されますので、このページをご確認ください。',

  // Vendor Show
  'userVendorShowComponent.heading': 'ベンダースポンサーシップ',
  'userVendorShowComponent.subheading':
    'イベント詳細から「スポンサーとして登録」ボタンをクリックしてスポンサーになることができます',

  // Vendor Info Card
  'userVendorInfoCardComponent.p1':
    'イベントの少なくとも1日前に、スライドを主催者にメールで送信する必要があります。あなたの持ち時間は10分のみであり、それに応じて計画する必要があることを念頭に置いてください。',
  'userVendorInfoCardComponent.p2':
    'ワークショップ/シンポジウム期間中、メジャースポンサーの2名の代表者に無料ランチが提供されます。セミナーランチョンの場合、ランチの数は無制限です。オンライン登録が必要です。',
  'userVendorInfoCardComponent.title':
    'ベンダーショー代表者のランチオプション：',
  'userVendorInfoCardComponent.body1.label':
    'セミナーランチョンベンダーショー：',
  'userVendorInfoCardComponent.body1.p':
    'ランチは無料ですが、オンライン登録が必要です。',
  'userVendorInfoCardComponent.body2.label':
    'ワークショップ/シンポジウムベンダーショー',
  'userVendorInfoCardComponent.body2.p':
    'ランチはオンライン登録プロセス中に購入できます。',
  'userVendorInfoCardComponent.vendorShowCard1.title':
    'ベンダーショーへの参加：',
  'userVendorInfoCardComponent.vendorShowCard1.li1':
    '各ベンダーは6席の展示テーブルを取得します。テーブル上に適切なものを展示でき、ペインターズテープを使用してテーブル後ろの壁にポスターを掲示できます。',
  'userVendorInfoCardComponent.vendorShowCard1.li2':
    '会議室入口隣のテーブルはメジャースポンサー用に予約されています。',
  'userVendorInfoCardComponent.vendorShowCard1.li3':
    'セミナーランチョンと午後のワークショップの場合、午前11時までに到着してセットアップしてください。フルデイワークショップの場合、午前8時までに到着してセットアップしてください。',
  'userVendorInfoCardComponent.vendorShowCard1.li4': `参加者を引きつけるために抽選賞品を持参することをお勧めします（ベンダーあたり1賞品に制限）。セミナーランチョンの場合、抽選は午後1時15分のセミナー終了時に行われます | ワークショップの場合、抽選は通常最終ワークショップセッション直前の午後4時頃に行われます。`,
  'userVendorInfoCardComponent.vendorShowCard2.title': 'ベンダーショー時間',
  'userVendorInfoCardComponent.vendorShowCard2.time-p1':
    'セミナーランチョンベンダーショー：',
  'userVendorInfoCardComponent.vendorShowCard2.time-label1':
    '午前11時 - 午後12時45分',
  'userVendorInfoCardComponent.vendorShowCard2.time-p2':
    '午後のワークショップベンダーショー：',
  'userVendorInfoCardComponent.vendorShowCard2.time-label2':
    '午前11時 - 午後12時15分',
  'userVendorInfoCardComponent.vendorShowCard2.time-p3':
    '午前のベンダーショー：',
  'userVendorInfoCardComponent.vendorShowCard2.time-label3':
    '午前8時 - 8時45分、午前10時30分 - 10時45分',
  'userVendorInfoCardComponent.vendorShowbtext1-p':
    'ワークショップ前に、あなたの名前、会社名、私たちの組織名、会議日を明記してください',
  'userVendorInfoCardComponent.vendorShowbtext1-label':
    'ワークショップの休憩時間中（通常午後2時30分 - 2時45分、午後3時45分 - 4時）。',
  'userVendorInfoCardComponent.vendorShowbtext2-span':
    'ベンダーショー展示資料を事前に会議会場に送付する予定の場合：',
  'userVendorInfoCardComponent.vendorShowbtext2-p':
    '会議会場ホテルのバンケットオフィスに送付できます（あなたの名前、会社名、私たちの組織名、会議日を明記してください）。',
  //payment history
  'userPaymentHistoryComponent.subheading':
    'すべての取引と返金詳細をここから確認',
  'userPaymentHistoryComponent.heading': '支払い履歴',

  // Special Payment
  'specialPaymentFormComponent.button.proceedToPayment': '支払いに進む',
  'specialPaymentFormComponent.returnButton.returnToNormalForm': 'Back',

  // Seminar Luncheons
  'userSeminarLuncheonsComponent.heading': 'セミナーランチョン',
  'userSeminarLuncheonsComponent.p1':
    '私たちのセミナーランチョン（通常無料）は、薬物発見と開発における選ばれた進歩についてのネットワーキングと学習のためのものです。',
  'userSeminarLuncheonsComponent.p2':
    'セミナーランチョン中のベンダーショーでは、参加者がベンダーと交流し、抽選賞品を獲得できます。抽選に参加するために名刺を必ずお持ちください！',
  'userSeminarLuncheonsComponent.p3':
    '今後のセミナーランチョンに関する情報については、',

  // Workshops
  'userWorkshopsComponent.heading': 'ワークショップ',
  'userWorkshopsComponent.p1':
    '私たちのワークショップは、薬物発見と開発の基礎的トピックを最小限のコストで参加者に提供します（例えば、学術参加者や自己負担の参加者の登録料は大幅に補助されています）。各ワークショップは本質的に、特定のトピックの基礎、進歩、応用、ケーススタディを網羅する短期コースです。講演者は、教科書の異なる章を教えるように、よく調整されたカリキュラムを提示します。ワークショップは通常フルデイイベントです。コース資料（PDFスライド）は便利な参考資料として参加者に提供されます。',
  'userWorkshopsComponent.p2':
    'ワークショップは通常対面で開催されますが、Zoom経由でバーチャルに開催される場合もあります。対面ワークショップは、イベント会場にいない参加者向けにウェブキャストされる場合もあります。',
  'userWorkshopsComponent.p3': '今後のワークショップに関する情報については、',

  // Symposia
  'userSymposiaComponent.heading': 'シンポジウム',
  'userSymposiaComponent.p1':
    '私たちのシンポジウムは会議セッションのようなもので、薬物発見と開発の分野における最新の進歩を網羅する個別のセミナーがあります。対面またはZoom経由でバーチャルに開催されます。対面シンポジウムは、現地にいない参加者向けにウェブキャストされる場合もあります。',
  'userSymposiaComponent.p2':
    '各シンポジウムは半日（午後）またはフルデイです。',
  'userSymposiaComponent.p2': '今後のシンポジウムに関する情報については、',

  //Webinar
  'userWebinarsComponent.heading': 'ウェビナー',
  'userWebinarsComponent.p1':
    'ウェビナーは通常、特定のトピックに関する1つまたは2つのオンラインプレゼンテーションを含み、通常1-2時間続きます。',
  'userWebinarsComponent.p2': `今後のウェビナーに関する情報については、`,

  // Dinner Seminar
  'userDinnerSeminarComponent.heading': 'ディナーセミナー',
  'userDinnerSeminarComponent.p1':
    '私たちのディナーセミナーはより少ない頻度で開催され、関連するトピックのいくつかのセミナーを含む場合があります。ディナーセミナー中にはベンダーショーも開催されます。',
  'userDinnerSeminarComponent.p2':
    '今後のディナーセミナーに関する情報については、',

  //Validation
  //only Alphabet Allow-
  'common.validation.onlyAlphabet': `#{name}は数字以外の文字のみ許可されます！`,

  // Sponsorship Info
  // Vendor Show Exhibition
  'userSponsorshipInfo.heading': '#{text}スポンサーシップ情報',
  'userSponsorshipInfo.content.vendorShow.h1': 'ベンダー展示:',
  'userSponsorshipInfo.content.p1': '#{text}として対面PBSSイベントに参加。',
  'userSponsorshipInfo.content.p2': '登録料に含まれるもの：',
  'userSponsorshipInfo.content.vendorShow.li1':
    'イベント全体を通じて会社資料を展示できるベンダーショーテーブルトップスペース。',
  'userSponsorshipInfo.content.vendorShow.li2':
    '助成価格でのワークショップ参加者2名。',
  'userSponsorshipInfo.content.vendorShow.li3':
    'イベントがワークショップの場合、プレゼンテーションのPDFスライドデッキ。',
  'userSponsorshipInfo.content.vendorShow.li4':
    '抽選への参加（参加者から名刺を集め、他のベンダーと一緒に抽選に参加して、選択した賞品を参加者にプレゼント）。',
  'userSponsorshipInfo.content.contactUs':
    '詳細については以下にお問い合わせください',
  // Happy Hour Sponsorship
  'userSponsorshipInfo.content.happyHour.h1':
    'ハッピーアワースポンサーシップ：',
  'userSponsorshipInfo.content.happyHour.li1':
    'イベント全体を通じて会社資料を展示できるベンダーショーテーブルトップスペース。',
  'userSponsorshipInfo.content.happyHour.li2':
    'イベントがワークショップの場合、プレゼンテーションのPDFスライドデッキ。',
  'userSponsorshipInfo.content.happyHour.li3':
    '助成価格でのワークショップ参加者2名。',
  'userSponsorshipInfo.content.happyHour.li4':
    '抽選への参加（参加者から名刺を集め、他のベンダーと一緒に抽選に参加して、選択した賞品を参加者にプレゼント）。',
  'userSponsorshipInfo.content.happyHour.li5':
    'あなたのスポンサーシップが会議アジェンダで認識されます。',
  'userSponsorshipInfo.content.happyHour.li6':
    'ハッピーアワー中に、あなたの会社とその提供について参加者に対して2分間の非公式な口頭広告/宣伝。',
  // Lunch Sponsorship
  'userSponsorshipInfo.content.lunchSponsorship.h1': 'ランチスポンサーシップ：',
  'userSponsorshipInfo.content.lunchSponsorship.li1':
    'イベント全体を通じて会社資料を展示できるベンダーショーテーブルトップスペース。',
  'userSponsorshipInfo.content.lunchSponsorship.li2':
    'イベントがワークショップの場合、プレゼンテーションのPDFスライドデッキ。',
  'userSponsorshipInfo.content.lunchSponsorship.li3':
    '助成価格でのワークショップ参加者2名。',
  'userSponsorshipInfo.content.lunchSponsorship.li4':
    '抽選への参加（参加者から名刺を集め、他のベンダーと一緒に抽選に参加して、選択した賞品を参加者にプレゼント）。',
  'userSponsorshipInfo.content.lunchSponsorship.li5':
    'あなたの代表者2名に無料ランチ。',
  'userSponsorshipInfo.content.lunchSponsorship.li6':
    'あなたのスポンサーシップが会議アジェンダで認識されます。',
  'userSponsorshipInfo.content.lunchSponsorship.li7':
    'ランチ中に、あなたの会社とその提供について参加者に対して2分間の非公式な口頭広告/宣伝。',
  'userSponsorshipInfo.content.lunchSponsorship.li8':
    '参加者がランチに来る前に、ランチテーブルであなたの会社の提供を宣伝するフライヤー配布。',
  // メジャースポンサーシップ
  'userSponsorshipInfo.content.major.h1': 'メジャースポンサーシップ：',
  'userSponsorshipInfo.content.major.li1':
    'ワークショップ/シンポジウム入口の隣にある専用ベンダーショーテーブルスペースで、イベント期間中に会社の資料を展示できます。',
  'userSponsorshipInfo.content.major.li2':
    'ワークショップまたはシンポジウムの無料席2席。',
  'userSponsorshipInfo.content.major.li3':
    'イベントがワークショップの場合、プレゼンテーションのPDFスライドデッキ。',
  'userSponsorshipInfo.content.major.li4':
    '抽選会への参加（参加者から名刺を集め、他のベンダーと一緒に抽選に参加し、お好みの賞品を参加者にプレゼント）。',
  'userSponsorshipInfo.content.major.li5': '代表者2名分の無料昼食。',
  'userSponsorshipInfo.content.major.li6':
    'ワークショップ/シンポジウム中に会社とその提供サービスについて10分間の口頭演台スライドプレゼンテーション。',
  'userSponsorshipInfo.content.major.li7':
    '会社の提供サービスを宣伝する会社チラシが会議参加者にメール送信され、全参加者向けのワークショップスライドデッキにも含まれます。',
  'userSponsorshipInfo.content.major.li8':
    '主催者/講演者/スポンサー向けの会議後ディナーへの代表者2名の夕食招待。',
  'userSponsorshipInfo.content.major.li9':
    '会議参加者の氏名と所属を受け取ります（登録時にオプトインした場合、メールアドレスも提供される可能性があります）。',
  // 抽選ルール
  'userSponsorshipInfo.content.raffleRules.h1': '抽選ルール：',
  'userSponsorshipInfo.content.raffleRules.li1':
    '抽選は通常、最後の休憩/ベンダーショーセッションの終了時と最終プレゼンテーションセッションの前に行われます。',
  'userSponsorshipInfo.content.raffleRules.li2':
    '抽選時間を最小限に抑えるため、参加する各ベンダーは事前に3名の当選者名（1名が当選者、他の2名がバックアップ）を引いておき、当選者名を迅速に発表できるようにする必要があります。',
  'userSponsorshipInfo.content.raffleRules.li3':
    '各ベンダー代表者は30秒間で自分の名前、会社名、提供サービスを発表します。',
  'userSponsorshipInfo.content.raffleRules.li4':
    '各ベンダーは賞品を1名の当選者に贈呈する必要があります。',
  'attendee-cart-screen-extra-message': ` <ul style="color: red; padding : 0px 10px ; margin: 0px;">
      <li><b>続行</b>ボタンをクリックする前に慎重に確認してください。</li>
      <li>クーポンコードをお持ちの場合は入力し、続行ボタンをクリックする前に慎重に確認してください。</li>
    </ul>`,
  'sponsor-cart-screen-extra-message': ` <ul style="color: red; padding : 0px 10px ; margin: 0px;">
      <li>続行する前にスポンサーおよびベンダー担当者の詳細を追加して保存してください。</li>
      <li>クーポンコードをお持ちの場合は入力し、続行する前に慎重に確認してください。</li>
      <li><b>続行</b>をクリックする前にすべての詳細を慎重に確認してください。</li>
    </ul>`,
  'attendee-screen-extra-message': `
    <ul style="color: red; padding : 0px 10px ; margin: 0px;">
      <li>続行する前に追加参加者を追加して保存してください。</li>
      <li>クーポンコードをお持ちの場合は入力し、続行する前に慎重に確認してください。</li>
      <li>一部の登録オプションでは、支払い前に資格確認フォームの提出が必要です。表示された画面でフォームを完了してください。</li>
      <li><b>続行</b>をクリックする前にすべての詳細を慎重に確認してください。</li>
    </ul>
  `,
  'qualificationForm.modalTitle': '資格確認フォーム',
  'qualificationForm.embedHint':
    'この画面でフォームを完了してください。送信後、確認が取れ次第、支払いに進みます。',
  'qualificationForm.confirmingMessage':
    'フォームの送信を確認しています。しばらくお待ちください。',
  'qualificationForm.notConfirmedMessage':
    '資格確認フォームがまだ確認できていません。フォームを送信してから再度お試しください。',
  'qualificationForm.pendingAlert':
    '1名以上の参加者に資格確認フォームが必要です。続行をクリックし、このページでフォームを完了してください。',
  'qualificationForm.popupBlockedMessage':
    'ブラウザが資格確認フォームのポップアップをブロックしました。このサイトのポップアップを許可してから再度お試しください。',
  'paymentCheckoutComponent.registration.extra': `
    <div style="color: red; padding : 0px 10px ; margin: 0px;">
      <span style="font-size: 14px;">イベントの10日前まで登録を変更できます。ご質問はinfo@pbss.orgまでお問い合わせください。</span>
    </div>
  `,
  'paymentCheckoutComponent.sponsor.major.extra': `
    <div style="color: red; padding : 0px 10px ; margin: 0px;">
      <span style="font-size: 14px;">スポンサーシップ登録およびベンダー代表者は、イベントの7日前まで変更できます。7日以内の変更については、PBSS管理者またはinfo@pbss.orgまでご連絡ください。返金の場合、クレジットカード処理手数料は差し引かれます。ご質問はinfo@pbss.orgまでお問い合わせください。</span>
    </div>
  `,
  'paymentCheckoutComponent.sponsor.non-major.extra': `
    <div style="color: red; padding : 0px 10px ; margin: 0px;">
      <span style="font-size: 14px;">スポンサーシップ登録およびベンダー代表者は、イベントの7日前まで変更できます。7日以内の変更については、PBSS管理者またはinfo@pbss.orgまでご連絡ください。返金の場合、クレジットカード処理手数料は差し引かれます。ご質問はinfo@pbss.orgまでお問い合わせください。</span>
    </div>
  `,
  'payment-success.registration.extra': `
払い戻しのご請求は、いつ行われたかに関わらず、クレジットカード決済手数料が差し引かれます。払い戻しのご請求は、アカウントにログイン後、「マイイベント」ページからオンラインで行ってください。私たちはボランティアによって運営されている団体であり、ボランティアの方々がこのような問題に対応する際の負担を最小限に抑える必要があるため、このポリシーをご理解いただければ幸いです。ポリシーは支部によって異なる場合がありますのでご了承ください。ご質問はinfo@pbss.orgまでお問い合わせください。  `,
  'payment-success.registration.extracontent1': `<ul><li class='extracontent1'>
            会議参加者の皆様：参加者からの返金リクエストは、イベント開始日の少なくとも3営業日前までにウェブサイトからご提出ください。返金はクレジットカード手数料を差し引いた全額を返金いたします。返金期限を過ぎた場合は、参加費は返金できません
            </li>
            <li class='extracontent1'>
              主要スポンサーシップ：スポンサーイベント開催日の2ヶ月前までは、500ドルのペナルティを差し引いた金額を返金いたします。返金期限を過ぎた場合は、スポンサーシップ料金は返金不可となります。
            </li>
            <li class='extracontent1'>
              ランチスポンサーシップ：スポンサーイベント開催日の2ヶ月前までは、300ドルのペナルティを差し引いた金額を返金いたします。返金期限を過ぎた場合は、スポンサーシップ料金は返金いたしかねます。
            </li>
             <li class='extracontent1'>
ハッピーアワースポンサーシップ：スポンサーイベント開催日の2ヶ月前までは、300ドルのペナルティを差し引いた金額を返金いたします。返金期限を過ぎた場合は、スポンサーシップ料金は返金いたしかねます。</li> 
             <li class='extracontent1'>

ベンダーショー：スポンサーイベント開催日の2週間前までは、100ドルのペナルティを差し引いた金額を返金いたします。返金期限を過ぎた場合は、スポンサー料は返金いたしかねます。</li></ul>`,
  'payment-success.sponsor.major.extra': `
     スポンサーシップ登録およびベンダー代表者は、イベントの7日前まで変更できます。7日以内の変更については、PBSS管理者またはinfo@pbss.orgまでご連絡ください。
  `,
  'payment-success.sponsor.non-major.extra': `
     スポンサーシップ登録およびベンダー代表者は、イベントの7日前まで変更できます。7日以内の変更については、PBSS管理者またはinfo@pbss.orgまでご連絡ください。
  `,
  'userSponsorshipInfo.content.raffleRules.li5':
    '当選するには本人が出席している必要があります。',
  'userSponsorshipInfo.content.raffleRules.contactUs': `詳細については、PBSSホームページから各PBSS支部のページをご覧いただくか、info@pbss.orgまでメールでお問い合わせください。`,
  'addAttendeeComponent.option.registration': '登録',
  'addAttendeeComponent.option.food': '食べ物',
  'addAttendeeComponent.button.webcastPopup.confirm':
    'ウェブキャストの出席確認',
  'addAttendeeComponent.button.webcastPopup.inPerson': '対面出席を選択',
  'addAttendeeComponent.button.webcastPopup.description':
    'ウェブキャストへの登録は、イベント開催地以外にお住まいの方のみご利用いただけます。イベント開催地にお住まいの方は、必ず会場での登録をお選びください。',
  'addAttendeeComponent.button.webcastPopup.title': 'ウェブキャスト登録確認',
  'addAttendeeComponent.sponsor.heroText.title': '参加者',
  'addAttendeeComponent.sponsor.heroText.subtitle': '参加者登録',
  'addAttendeeComponent.contactUsFormComponent.heading': 'お問い合わせ',
  'addAttendeeComponent.contactUsFormComponent.email': 'info.japan@pbss.org',
  'adsComponent.cart.payment.goBackButton': 'Go Back to Ads',
  'adsComponent.cart.payment.urlPath': 'ads',
  'adsComponent.cart.payment.tableTitle': '広告',
  'adsComponent.cart.payment.totalAmountHeading': 'Total amount to be paid',
  'userAdsFormComponent.form.validation.vendorName':
    'Please fill out vendor name',
  'userAdsFormComponent.form.placeholder.vendorName': 'Vendor Name',
  'userAdsFormComponent.form.placeholder.attachmentURL':
    '外部 URL / 広告ポスター アドレス (例: www.example.com)',
  'userAdsFormComponent.form.validation.attachmentURL':
    '添付ファイルのURLを入力してください',
  'userAdsFormComponent.form.validation.attachmentUrl.invalidFormat':
    '添付ファイルの URL 形式が無効です',
  'userAdsFormComponent.form.placeholder.email': 'Email',
  'userAdsFormComponent.form.validation.email': 'Please fill out email',
  'userAdsFormComponent.form.validation.startDate': 'Please select start date',
  'userAdsFormComponent.form.placeholder.startDate': 'Start date of Ad',
  'userAdsFormComponent.form.placeholder.months': 'Enter the months of the ad',
  'userAdsFormComponent.form.validation.adType': 'Please select ad type',
  'userAdsFormComponent.form.placeholder.adType': 'Select ads type',
  'userAdsFormComponent.form.placeholder.uploadLogo': 'Upload logo',
  'userAdsFormComponent.form.validation.uploadLogo.acceptedFormats':
    'Accepts only image files (png, jpg, jpeg)',
  'userAdsFormComponent.form.placeholder.description':
    'Textual ads description  (150 character )',
  'userAdsFormComponent.form.placeholder.attachmentURL':
    'External url / ad poster address (e.g. www.example.com)',

  'userAdsFormComponent.form.validation.uploadLogo.maxSize': (fileType) => {
    return `Maximum file size is ${fileType}MB`;
  },
  'userAdsFormComponent.form.saveDraft': 'Save',
  'userAdsFormComponent.form.proceed': 'Proceed to Continue',
  'userAdsFormComponent.form.cancel': 'Cancel',
  'userCommonAdsListingCard.button.edit': '編集',
  'userCommonAdsListingCard.search': 'Search for ads',
  'userCommonAdsListingCard.pageName': 'Ad',
  'userCommonAdsListingCard.selectPlaceholder': 'Status',
  'userCommonAdsListingCard.alert.title': 'No Ads Available',
  'userCommonAdsListingCard.viewMoreAds': 'View More Ads',
  'adsComponent.cart.payment.selectAdType': '広告タイプを選択',
  'adsComponent.cart.payment.months': '月を入力',
  'adsComponent.cart.payment.vendor': 'ベンダー名を入力してください',
  'adsComponent.cart.payment.description': '広告の説明を入力してください',
  'userAssetsUploadComponent.uploadFile': 'チラシをアップロード',
  'userAssetsUploadComponent.submit': '続く',

  // Pbss International Component
  'mainLayoutComponent.navbar.mainPage': 'Main Page',
  'mainLayoutComponent.navbar.aboutPbss': 'About',
  'mainLayoutComponent.navbar.aboutPbss.pbss': 'PBSS',
  'mainLayoutComponent.navbar.events': 'Events',
  'mainLayoutComponent.navbar.pickALocation': 'Pick a Location',
  'mainLayoutComponent.navbar.pbssInternational': 'PBSS International',
  'mainLayoutComponent.navbar.eventTypesInfo': 'Event Types Info',
  'mainLayoutComponent.navbar.eventTypesInfo.seminarLuncheons':
    'Seminar Luncheons',
  'mainLayoutComponent.navbar.eventTypesInfo.workshops': 'Workshops',
  'mainLayoutComponent.navbar.eventTypesInfo.symposia': 'Symposia',
  'mainLayoutComponent.navbar.eventTypesInfo.webinars': 'Webinars',
  'mainLayoutComponent.navbar.eventTypesInfo.dinnerSeminars': 'Dinner Seminars',
  'mainLayoutComponent.navbar.sponsorships': 'Sponsorships',
  'mainLayoutComponent.navbar.chapters': 'Chapters',
  'mainLayoutComponent.navbar.contactUs': 'Contact Us',
  'mainLayoutComponent.navbar.jobPostings': 'Job Postings',
  'mainLayoutComponent.navbar.adPostings': 'Ads',
  'mainLayoutComponent.navbar.resources': 'Resources',
  'mainLayoutComponent.navbar.resources.stemOutreach': 'STEM outreach',
  'mainLayoutComponent.navbar.resources.industryOutreach': 'Industry News',
  'mainLayoutComponent.navbar.resources.careerMentorship': 'Career Mentorship',
  'mainLayoutComponent.navbar.resources.partners':
    'Partner Organizations of PBSS',
  'mainLayoutComponent.navbar.faq': 'FAQ',

  // Profile View
  'profileViewComponent.heading': 'アカウント',
  'profileViewComponent.subheading': '管理者機能に切り替え',
  'profileViewComponent.button.changePassword': 'パスワードを変更',
  'profileViewComponent.button.createJobPosting': '求人の投稿または管理',
  'profileViewComponent.button.createAd': '広告の投稿または管理',
  'profileViewComponent.button.myCart': '自分のカート​',
  'profileViewComponent.button.myEvents': '自分のイベント',
  'profileViewComponent.button.updateProfile': 'プロフィールを更新する​',
  'profileViewComponent.button.joinPbss': 'PBSSに参加する',
  'profileViewComponent.button.logout': 'ログアウト',
  'profileViewComponent.button.login': 'ログイン',
  'profileViewComponent.button.myAccount': 'マイアカウント',

  // Pbss In Map
  'pbssInMapComponent.specialAnnouncementHeading': '特別なお知らせ​',

  // Jobs And Ads Tabs
  'jobsAndAdsTabs.ads': '有料広告',
  'jobsAndAdsTabs.jobs': '求人情報',

  //Event Listing
  'eventListing.regClosed.title': '登録は終了しました',
  'eventListing.regClosed.message':
    'このイベントへの登録は終了しました。管理者までご連絡ください。',
  'eventListing.regClosed.email': 'info@pbss.org',
  'eventListing.regClosed.moreInfo': '詳細についてはこちらをご覧ください。',
  'eventListing.regOpen.title': '今すぐ登録',
  'eventListing.regClosed.title': '登録は終了しました',
  'eventListing.speaker': 'スピーカー',
  'eventListing.comingSoon': 'Coming Soon​',

  //Past Events Listing
  'pastEventsListing.title': '過去のイベント',

  //Sponsor Listing
  'sponsorListing.title': 'イベントスポンサー',

  //Footer
  'footer.text': `© ${new Date().getFullYear()} All rights reserved, Pharmaceutical & BioScience Society International.`,
  'footer.links.aboutUs': 'About Us',
  'footer.links.contactUs': 'Contact Us',
  'footer.links.jobs': 'Jobs',
  'footer.links.ads': 'Ads',
  'footer.links.subscribe': 'ニュースレター購読',
  'footer.links.privacyPolicy':
    '購読することで、プライバシーポリシーに同意したものとみなされます。',

  //Chapter Page
  'chapterPage.otherChapterEventData.title':
    '他のChapterの今後のイベント (Webcast)',
  'chapterPage.eventChapter.title': '今後の',
  'chapterPage.eventChapter.title2': 'PBSS イベント',

  //Admin Actions Dropdown Component
  'adminActionsDropdownComponent.deleteText': '消去',
  'adminActionsDropdownComponent.cancelText': 'キャンセル',
  'adminActionsDropdownComponent.saveText': '保存',
  'adminActionsDropdownComponent.editText': '編集',
  'adminActionsDropdownComponent.addEditChapterContent':
    '支部コンテンツの追加/編集',
  'adminActionsDropdownComponent.editSponsorshipInfo':
    'スポンサーシップ情報の編集',
  'adminActionsDropdownComponent.viewText': '表示',
  'adminActionsDropdownComponent.copyText': 'コピー',
  'adminActionsDropdownComponent.changeStatusText.part1': '変更',
  'adminActionsDropdownComponent.changeStatusText.part2': '状態',
  'adminActionsDropdownComponent.changeWillReceiveText.part1': '変更',
  'adminActionsDropdownComponent.changeWillReceiveText.part2': 'メール配信',
  'adminActionsDropdownComponent.eventRegistration': '登録',
  'adminActionsDropdownComponent.eventRegistrationWaitingList': '待ちリスト',
  'adminActionsDropdownComponent.eventOptions': 'オプション',
  'adminActionsDropdownComponent.eventEmailScheduler': 'メールスケジューラー',
  'adminActionsDropdownComponent.eventEmailScheduler.noTemplateData':
    'テンプレートデータが見つかりませんでした。',
  'adminActionsDropdownComponent.eventEmailScheduler.backToScheduler':
    'イベントメールテンプレートスケジューラーに戻る',
  'adminActionsDropdownComponent.eventRefund': '返金',
  'adminActionsDropdownComponent.viewCouponUsers': 'クーポンユーザーの表示',
  'adminActionsDropdownComponent.editEmailTemplate': 'メールテンプレートの編集',
  'adminActionsDropdownComponent.editScheduleOfTemplate':
    'テンプレートのスケジュールの編集',
  'adminActionsDropdownComponent.sendDirectEmail': '直接メール送信',
  'adminActionsDropdownComponent.sendDirectEmailConfirmTitle': '直接メール送信',
  'adminActionsDropdownComponent.sendDirectEmailConfirmDescription':
    'このメールを送信してもよろしいですか？',
  'adminActionsDropdownComponent.sendDirectEmailSecondConfirmDescription':
    'このメールは選択したすべての受信者にすぐに送信されます。「Yes」をクリックして続行するか、「Cancel」をクリックしてキャンセルしてください。',
  'adminActionsDropdownComponent.editAttendee': '参加者を編集',
  'adminActionsDropdownComponent.deleteAttendee': '参加者の削除',
  'adminActionsDropdownComponent.cancelAttendee': '参加者のキャンセル',
  'adminActionsDropdownComponent.saveAttendee': '参加者の保存',

  //Confirmation Action Component
  'adminActionsDropdownComponent.addAdditionalAttendee': '参加者の追加',
  'adminActionsDropdownComponent.addAdditionalAttendee.vendorRepLimitExhausted':
    'ベンダーリポジトリの制限に達しました。',
  'adminActionsDropdownComponent.addAdditionalAttendee.vendorRepLimitExhausted.title':
    'ベンダー担当者の上限に達しました',

  //Attendees Cart Component
  'userAttendeeCartComponent.credit.totalAmountToBePaid': '支払い総額',
  'userAttendeeCartComponent.credit.subtotal': '小計',
  'userAttendeeCartComponent.credit.discount': '割引',
  'userAttendeeCartComponent.credit.useCredit': 'クレジットを使用する',

  //Add Attendee Component
  'userAddAttendeeComponent.goBackToEventDetails': 'イベントの詳細に戻る',

  //Chapter Page
  //Chapter Page
  'chapterPage.chapterHeading.pbss':
    'Japan Pharmaceutical & BioScience Society (chapter of PBSS International)',
  'chapterPage.chapterHeading.welcome': 'へようこそ',
  'chapterPage.chapterHeading.pbssInternational':
    'PBSSインターナショナルの支部',
  'chapterPage.chapterHeading.pbssInternational.seattle': 'シアトル',
  'chapterPage.chapterHeading.pbssInternational.boston': 'ボストン',
  'chapterPage.chapterHeading.pbssInternational.vancouver': 'バンクーバー',
  'chapterPage.chapterHeading.pbssInternational.korea': '韓国',
  'chapterPage.chapterHeading.pbssInternational.china': '中国',
  'chapterPage.chapterHeading.pbssInternational.india': 'インド',
  'chapterPage.chapterHeading.pbssInternational.default': 'ようこそ',
  'chapterPage.chapterHeading.welcome.japan':
    'Japan Pharmaceutical & BioScience Society (chapter of PBSS International)へようこそ',

  //Event Listing
  'eventListing.filterBy': 'Filter by​',
  'eventListing.eventType': 'イベント種別​',
  'eventListing.chapter': '支部',
  'eventListing.date': '日付',
  'eventListing.year': '年',
  'eventListing.all': '全て',
  'eventListing.selectDefaultChapter': 'デフォルトのChapterを選択してください',
  'eventListing.selectDefaultStatus':
    'デフォルトのステータスを選択してください',
  'eventListing.selectDefaultLocation': 'デフォルトの場所を選択してください',
  'eventListing.selectLocation': 'Job Location',
  'eventListing.selectDefaultCategory':
    'デフォルトのカテゴリを選択してください',
  'eventListing.selectDefaultYear': '年を選択',
  'eventListing.selectYear': '年',
  'jobListing.selectYear': 'Year',
  'jobListing.selectDefaultYear': 'Select Year',
  'eventListing.history': '歴史',
  'eventListing.searchByEventName': 'イベント名で検索',
  'eventListing.clearFilter': 'フィルターの削除​',
  'eventListing.attended': '出席済',
  'eventListing.upcoming': '今後の予定',
  'jobListing.clearFilter': 'Clear Filter​',

  //Sponsor Info Details Component
  'sponsorInfoDetailsComponent.title': 'スポンサーシップ情報',
  'sponsorInfoDetailsComponent.content.vendorShowExhibition.title':
    'ベンダーショー展示',
  'sponsorInfoDetailsComponent.content.happyHourSponsorship.title':
    'ハッピーアワースポンサーシップ',
  'sponsorInfoDetailsComponent.content.lunchSponsorship.title':
    'ランチスポンサーシップ',
  'sponsorInfoDetailsComponent.content.majorSponsorship.title':
    'メジャースポンサーシップ',
  'sponsorInfoDetailsComponent.content.raffleRules.title': '抽選ルール',
  'sponsorInfoDetailsComponent.content.cancellationPolicy.title':
    'キャンセルポリシー',
  'sponsorInfoDetailsComponent.content.vendorShowExhibition': `<p class='sponsorshipInfo'>対面式のPBSSイベントへの出展者としての参加。</p>
              <p class='sponsorshipInfo'>ご登録料金には以下の内容が含まれます：</p>
              <ol class='sponsorshipInfoOrderedList'>
                <li class='sponsorshipInfoList'>
                 出展者は、イベント期間中、自社の資料を展示するためのテーブルトップスペースをご利用いただけます
                </li>
                <li class='sponsorshipInfoList'>ワークショップに2名参加、補助価格での参加が可能です。</li>
                <li class='sponsorshipInfoList'>
                  イベントがワークショップの場合、プレゼンテーションのPDFスライドデッキ。
                </li>
                <li class='sponsorshipInfoList'>
                 抽選会への参加（当社の参加者から名刺を収集し、他の出展者と共に抽選に参加し、参加者へ任意の賞品を贈呈する）
                </li>
              </ol>
              <p class='sponsorshipInfo'>
               詳細については、お問い合わせください。

                <a href="mailto:info@pbss.org">info@pbss.org</a>
              </p>`,
  'sponsorInfoDetailsComponent.content.happyHourSponsorship': `
            <p class='sponsorshipInfo'>
              対面式PBSSイベントへの参加（ハッピーアワースポンサーとして）。
            </p>
            <p class='sponsorshipInfo'>ご登録には以下の内容が含まれます：</p>
            <ol class='sponsorshipInfoOrderedList'>
              <li class='sponsorshipInfoList'>
                出展者は、イベント期間中、自社の資料を展示できるテーブルスペースを提供します。

              </li>
              <li class='sponsorshipInfoList'>
               イベントがワークショップの場合、プレゼンテーションのPDFスライドデッキ。
              </li>
              <li class='sponsorshipInfoList'>ワークショップに2名参加、補助価格での参加が可能です。</li>
              <li class='sponsorshipInfoList'>
                抽選会への参加（当社の参加者から名刺を収集し、他の出展者と共に抽選に参加し、参加者へ任意の賞品を贈呈する）
              </li>
              <li class='sponsorshipInfoList'>ご支援は会議の議事日程に記載されています。</li>
              <li class='sponsorshipInfoList'>
               2分間のカジュアルな口頭での広告/紹介文を、当社の参加者向けにハッピーアワー中にご提供いただきます。
              </li>
            </ol>
            <p class='sponsorshipInfo'>
               詳細については、お問い合わせください。
                <a href="mailto:info@pbss.org">info@pbss.org</a>
              </p>
          `,
  'sponsorInfoDetailsComponent.content.lunchSponsorship': `<p class='sponsorshipInfo'>対面式PBSSイベントへのランチスポンサーとしての参加。</p>
            <p class='sponsorshipInfo'>ご登録料金には以下の内容が含まれます：</p>
            <ol class='sponsorshipInfoOrderedList'>
              <li class='sponsorshipInfoList'>
出展者は、イベント期間中、自社の資料を展示できるテーブルトップスペースをご利用いただけます。
              </li>
              <li class='sponsorshipInfoList'>
               イベントがワークショップの場合、プレゼンテーションのPDFスライドデッキ。
              </li>
              <li class='sponsorshipInfoList'>ワークショップに2名参加、補助価格での参加が可能です。</li>
              <li class='sponsorshipInfoList'>
                抽選会への参加（当社の参加者から名刺を収集し、他の出展者と共に抽選に参加し、参加者へ任意の賞品を贈呈する）
              </li>
              <li class='sponsorshipInfoList'>ご支援は会議の議事日程に記載されています。</li>
              <li class='sponsorshipInfoList'>
                2分間のカジュアルな口頭での広告/紹介文を、当社の参加者向けにランチ中にご提供いただきます。
              </li>
              <li class='sponsorshipInfoList'>
                     ランチタイム前に来場者がランチテーブルに着く前に、貴社のサービスや商品を宣伝するためのフライヤー配布を、

              </li>
            </ol>
            <p class='sponsorshipInfo'>
               詳細については、お問い合わせください。
                <a href="mailto:info@pbss.org">info@pbss.org</a>
              </p>`,
  'sponsorInfoDetailsComponent.content.majorSponsorship': `<p class='sponsorshipInfo'>対面式PBSSイベントへのメジャースポンサーとしての参加。</p>
            <p class='sponsorshipInfo'>ご登録料金には以下の内容が含まれます：</p>
            <ol class='sponsorshipInfoOrderedList'>
              <li class='sponsorshipInfoList'>
                 専用出展者用展示スペースを、ワークショップ/シンポジウムの入口隣に設置し、イベント期間中、貴社の資料を展示いただけます。
              </li>
              <li class='sponsorshipInfoList'>2 free workshop or symposium seats.</li>
              <li class='sponsorshipInfoList'>
               イベントがワークショップの場合、プレゼンテーションのPDFスライドデッキ。
              </li>
              <li class='sponsorshipInfoList'>
                抽選会への参加（当イベントの参加者から名刺を収集し、他の出展者と共に抽選に参加し、参加者へお好みの賞品を贈呈します）。
              </li>
              <li class='sponsorshipInfoList'>ご担当者様向けに無料のランチを2回ご用意しております。.</li>
              <li class='sponsorshipInfoList'>
                ワークショップ/シンポジウムにおいて、貴社とそのサービスについて10分間の口頭発表とスライドプレゼンテーションを行うこと。
              </li>
              <li class='sponsorshipInfoList'>
                貴社のサービスや製品を宣伝する会社案内は、会議の参加者全員にメールで送信され、またワークショップのスライド資料にも含まれます。
              </li>
              <li class='sponsorshipInfoList'>
                主催者/講演者/スポンサー向けの会議後の夕食会への招待状（2名分）
              </li>
              <li class='sponsorshipInfoList'>
                会議の出席者の氏名と所属機関（登録プロセス中に同意した場合、メールアドレスが提供される場合があります）が提供されます。
              </li>
            </ol>
            <p class='sponsorshipInfo'>
               詳細については、お問い合わせください。t
                <a href="mailto:info@pbss.org">info@pbss.org</a>
              </p>`,

  'sponsorInfoDetailsComponent.content.raffleRules': `<ul><li class='sponsorshipInfoList'>
               抽選会は通常、最後の休憩時間/出展者展示セッションの終了後、最終プレゼンテーションセッションの前に行われます。
            </li>
            <li class='sponsorshipInfoList'>
              抽選時間を最小限に抑えるため、参加する各出店者は事前に3名の当選者名（1名を当選者、残り2名を予備当選者）を抽選し、当選者の名前を迅速に発表できるようにする必要があります。
            </li>
            <li class='sponsorshipInfoList'>
             各ベンダーの代表者は、名前、会社名、および提供サービスを発表するために30秒間与えられます。
            </li>
            <li class='sponsorshipInfoList'>各出店者は、1名の当選者に賞品を1つだけ贈呈する必要があります。</li>
            <li class='sponsorshipInfoList'>当選者は、出席者でなければなりません。</li></ul>`,
  'sponsorInfoDetailsComponent.content.cancellationPolicy': `<ul><li class='sponsorshipInfoList'>
            会議参加者の皆様：参加者からの返金リクエストは、イベント開始日の少なくとも3営業日前までにウェブサイトからご提出ください。返金はクレジットカード手数料を差し引いた全額を返金いたします。返金期限を過ぎた場合は、参加費は返金できません
            </li>
            <li class='sponsorshipInfoList'>
              主要スポンサーシップ：スポンサーイベント開催日の2ヶ月前までは、500ドルのペナルティを差し引いた金額を返金いたします。返金期限を過ぎた場合は、スポンサーシップ料金は返金不可となります。
            </li>
            <li class='sponsorshipInfoList'>
              ランチスポンサーシップ：スポンサーイベント開催日の2ヶ月前までは、300ドルのペナルティを差し引いた金額を返金いたします。返金期限を過ぎた場合は、スポンサーシップ料金は返金いたしかねます。
            </li>
             <li class='sponsorshipInfoList'>
ハッピーアワースポンサーシップ：スポンサーイベント開催日の2ヶ月前までは、300ドルのペナルティを差し引いた金額を返金いたします。返金期限を過ぎた場合は、スポンサーシップ料金は返金いたしかねます。</li> 
             <li class='sponsorshipInfoList'>

ベンダーショー：スポンサーイベント開催日の2週間前までは、100ドルのペナルティを差し引いた金額を返金いたします。返金期限を過ぎた場合は、スポンサー料は返金いたしかねます。</li>
   <li class='sponsorshipInfoList'>払い戻しのご請求は、いつ行われたかに関わらず、クレジットカード決済手数料が差し引かれます。払い戻しのご請求は、アカウントにログイン後、「マイイベント」ページからオンラインで行ってください。私たちはボランティアによって運営されている団体であり、ボランティアの方々がこのような問題に対応する際の負担を最小限に抑える必要があるため、このポリシーをご理解いただければ幸いです。ポリシーは支部によって異なる場合がありますのでご了承ください。ご質問は<a href="mailto:info@pbss.org">info@pbss.org</a>までお問い合わせください。,
</li>
</ul>`,

  // Faq Component
  'faqComponent.title': 'よくある質問',
  'faqComponent.contactUs': 'お問い合わせ：',
  'faqComponent.contactUs.link': 'こちらをクリック',
  'faqComponent.contactUs.email': 'info@pbss.org',
  'faqComponent.faq.content.title': 'PBSSに参加するのに会費は必要ですか？',
  'faqComponent.faq.content.description': 'いいえ。会員登録は無料です。',
  'faqComponent.faq.content.title2':
    'ベンダー講演者に関するPBSSの方針は何ですか？',
  'faqComponent.faq.content.description2': `PBSSの会合に講演者を提供したいというベンダーからの関心をよく受けますが、商業的な宣伝や特定ベンダーへのえこひいきと受け取られることを避けるため、PBSSでは原則としてベンダーによる講演を禁止しています。ただし、ベンダーが他にない独自技術を有しており、それについて話を聞きたい場合には、例外的に許可されることがあります。妥協案として、ベンダーがその技術に詳しいクライアントの科学者を推薦することは可能です。`,
  'faqComponent.faq.content.title3':
    '会員情報の共有に関するPBSSの方針は何ですか？',
  'faqComponent.faq.content.description3': `会員のプライバシーを保護するため、会員リストはPBSS業務にのみ使用され、PBSS管理部門以外のいかなる個人または団体とも共有されることはありません。`,
  'faqComponent.faq.content.title4': 'PBSSは出席証明書を提供していますか？',
  'faqComponent.faq.content.description4': `<p>特別なリクエストがあった場合には、出席証明書の電子コピー（PDF）を追加料金でご提供できます。米国内イベントの場合、通常は50ドルです。ご希望の方は、イベントの開催日とタイトルを明記の上、<a href="mailto:info@pbss.org">info@pbss.org</a> までご連絡ください。</p>`,
  'faqComponent.contactUs.or': 'またはメールで',
  'faqComponent.faq.content.title5': 'PBSS キャンセルポリシーとは何ですか?',
  'faqComponent.faq.content.description5': `
  <p>会議参加者の皆様：参加者からの返金リクエストは、イベント開始日の少なくとも3営業日前までにウェブサイトからご提出ください。返金はクレジットカード手数料を差し引いた全額を返金いたします。返金期限を過ぎた場合は、参加費は返金できません</p>
  <p>主要スポンサーシップ：スポンサーイベント開催日の2ヶ月前までは、500ドルのペナルティを差し引いた金額を返金いたします。返金期限を過ぎた場合は、スポンサーシップ料金は返金不可となります。</p>
  <p>ランチスポンサーシップ：スポンサーイベント開催日の2ヶ月前までは、300ドルのペナルティを差し引いた金額を返金いたします。返金期限を過ぎた場合は、スポンサーシップ料金は返金いたしかねます。</p>
  <p>ハッピーアワースポンサーシップ：スポンサーイベント開催日の2ヶ月前までは、300ドルのペナルティを差し引いた金額を返金いたします。返金期限を過ぎた場合は、スポンサーシップ料金は返金いたしかねます。</p>
  <p>ベンダーショー：スポンサーイベント開催日の2週間前までは、100ドルのペナルティを差し引いた金額を返金いたします。返金期限を過ぎた場合は、スポンサー料は返金いたしかねます</p>,
    <P>払い戻しのご請求は、いつ行われたかに関わらず、クレジットカード決済手数料が差し引かれます。払い戻しのご請求は、アカウントにログイン後、「マイイベント」ページからオンラインで行ってください。私たちはボランティアによって運営されている団体であり、ボランティアの方々がこのような問題に対応する際の負担を最小限に抑える必要があるため、このポリシーをご理解いただければ幸いです。ポリシーは支部によって異なる場合がありますのでご了承ください。ご質問はinfo@pbss.orgまでお問い合わせください。</p>`,

  'faqComponent.contactUs.or': 'or email to',
  // User Update Profile Component
  'userUpdateProfileComponent.first_name.validationMessage':
    '名は空欄にできません',
  'userUpdateProfileComponent.first_name.placeholder': '名を入力してください',
  'userUpdateProfileComponent.title.validationMessage':
    'タイトルは空欄にできません',
  'userUpdateProfileComponent.title.placeholder': 'タイトルを入力してください',
  'userUpdateProfileComponent.address.validationMessage':
    '住所は空欄にできません',
  'userUpdateProfileComponent.address.placeholder': '住所を入力してください',
  'userUpdateProfileComponent.city.validationMessage': '都市は空欄にできません',
  'userUpdateProfileComponent.city.placeholder': '市区町村名を入力してください',
  'userUpdateProfileComponent.notes.placeholder': 'メモを入力してください',
  'userUpdateProfileComponent.last_name.validationMessage':
    '姓は空欄にできません',
  'userUpdateProfileComponent.last_name.placeholder': '姓を入力してください',
  'userUpdateProfileComponent.company.validationMessage':
    '会社は空欄にできません',
  'userUpdateProfileComponent.company.placeholder': '会社名を入力してください',
  'userUpdateProfileComponent.address2.validationMessage':
    '住所は空欄にできません',
  'userUpdateProfileComponent.address2.placeholder': '住所を入力してください',
  'userUpdateProfileComponent.state.placeholder': '州/県/区',
  'userUpdateProfileComponent.postal_code.placeholder':
    '郵便番号を入力してください',
  'userUpdateProfileComponent.phone_number.placeholder':
    '電話番号を入力してください',
  'userUpdateProfileComponent.local_chapter_id.validationMessage':
    'ローカルChapterは空欄にできません',
  'userUpdateProfileComponent.local_chapter_id.placeholder':
    'デフォルトのChapterを選択してください',
  'userUpdateProfileComponent.email.validationMessage':
    'メールアドレスは空欄にできません',
  'userUpdateProfileComponent.email.placeholder':
    'メールアドレスを入力してください',
  'userUpdateProfileComponent.mail_preference.validationMessage':
    'メール設定は空欄にできません',
  'userUpdateProfileComponent.mail_preference.placeholder':
    'メールの設定を選択してください',
  'userUpdateProfileComponent.mail_preference.label':
    'お知らせを受け取るPBSS Chapterを選択してください',
  'userUpdateProfileComponent.mail_preference.emptyStateInfo':
    'Chapterを1つでも選択すると、すべてのメールを自動的に受け取ることになります。',
  'userUpdateProfileComponent.area_of_interest.label': '関心分野を選択',
  'userUpdateProfileComponent.area_of_interest.placeholder':
    '興味のある分野を選択してください',
  'userUpdateProfileComponent.area_of_interest.validationMessage':
    '関心領域は空欄にしないでください',
  'userUpdateProfileComponent.update_profile': 'プロフィールを更新する',
  'userUpdateProfileComponent.cancel': 'キャンセル',
  'userUpdateProfileComponent.area_of_interest.label2':
    '次のテキストボックスに他の関心を追加できます。複数のオプションを区切るにはコンマを使用します。',
  'userUpdateProfileComponent.email.textMessage':
    'アカウントのメールアドレス変更をご希望の場合は、お問い合わせください。',
  'userUpdateProfileComponent.local_chapter_id.label':
    'ローカルデフォルトChapterを選択してください',
  'userUpdateProfileComponent.phone_number.label': '電話番号',
  'userUpdateProfileComponent.postal_code.label': '郵便番号',
  'userUpdateProfileComponent.state.label': '都道府県',
  'userUpdateProfileComponent.address2.label': '住所2',
  'userUpdateProfileComponent.company.label': '会社名/所属',
  'userUpdateProfileComponent.last_name.label': '苗字',
  'userUpdateProfileComponent.notes.label': '注記',
  'userUpdateProfileComponent.city.label': '市',
  'userUpdateProfileComponent.country.label': '国',
  'userUpdateProfileComponent.address.label': '住所1',
  'userUpdateProfileComponent.first_name.label': '名',
  'userUpdateProfileComponent.title.label': 'タイトル',
  'userUpdateProfileComponent.subheading':
    'Pharmaceutical & BioScience Society',
  'userUpdateProfileComponent.update_profile': 'プロフィールを更新する​',
  'userUpdateProfileComponent.country.validationMessage':
    '国名は空欄にできません',
  'userUpdateProfileComponent.country.placeholder': '国を選択してください',
  'userUpdateProfileComponent.country.area_of_interest.label':
    '関心のある分野をコンマで区切って入力してください',

  //Change Password
  'changePasswordForm.old_password.validationMessage':
    '古いパスワードを入力してください​',
  'changePasswordForm.new_password.validationMessage':
    '新しいパスワードを入力してください',
  'changePasswordForm.old_password.placeholder':
    '古いパスワードを入力してください',
  'changePasswordForm.new_password.placeholder':
    '新しいパスワードを入力してください',
  'changePasswordForm.confirm_password.placeholder':
    '確認パスワードを入力してください',
  'changePasswordForm.old_password.label': '古いパスワード​',
  'changePasswordForm.new_password.label': '新しいパスワード',
  'changePasswordForm.change_password': 'パスワードを変更',

  //Jobs
  'JobsListingComponent.button.pay': '支払い',
  'userJobsComponent.pageName': '求人',
  'userJobsComponent.heading': 'Add New Job',
  'userJobsComponent.subheading.part1':
    'Our job posting service shares opportunities in the pharmaceutical and bioscience industries. In addition to website display,',
  'userJobsComponent.subheading.part2':
    ' these ads are also published in our twice-monthly email newsletters.',
  'userJobsComponent.uploadLogoText': 'Upload Logo',
  'userJobsComponent.paymentText':
    '掲載を進めるには、お支払い手続きを完了してください。',
  'userJobsComponent.position.validationMessage': '職種を入力してください',
  'userJobsComponent.position.placeholder': 'Position / Designation',
  'userJobsComponent.employer.validationMessage': '雇用主名を入力してください',
  'userJobsComponent.employer.placeholder': 'Employer name',
  'userJobsComponent.cart.employer.placeholder': (title) =>
    `Enter your employer`,
  'userJobsComponent.cart.position.placeholder': (title) =>
    `Enter your position`,
  'userJobsComponent.location.validationMessage': 'Please fill out location',
  'userJobsComponent.location.placeholder': 'Location',
  'userJobsComponent.contact_info.placeholder': 'Contact information',
  'userJobsComponent.attachment_url.validationMessage':
    'Please fill out attachment url or email',
  'userJobsComponent.attachment_url.placeholder':
    'Apply Now Destination (URL or Email)',
  'userJobsComponent.start_date.validationMessage': 'Please select start date',
  'userJobsComponent.start_date.placeholder': 'Start date of Job',
  'userJobsComponent.months.placeholder': '勤務期間（月数）を入力してください',
  'userJobsComponent.job_fee_id.validationMessage':
    '求人の種類を選択してください',
  'userJobsComponent.job_fee_id.placeholder': '求人の種類を選択',
  'userJobsComponent.description.validationMessage':
    'Please fill out description',
  'userJobsComponent.description.placeholder': 'Job Description',
  'userJobsComponent.requirement.validationMessage':
    'Please fill out requirement',
  'userJobsComponent.requirement.placeholder': 'Job Requirements',
  'userJobsComponent.submit&CheckoutText': '送信して決済へ進む',
  'userJobsComponent.save': '保存',

  //Jobs Cart
  'userJobsComponent.goBackToJobPosting': 'Go Back to Job Posting',
  'userJobsComponent.totalAmountToBePaid': 'Total amount to be paid',
  'userJobsComponent.pageName': 'Job',
  'userJobsComponent.submit&CheckoutText': 'Submit & Checkout',

  //Jobs Cart Table
  'userJobsComponent.employer.label': 'Employer Name',
  'userJobsComponent.position.label': 'Position',
  'userJobsComponent.job_fee_id.label': 'Job Type',
  'userJobsComponent.months.label': 'Job Months',
  'userJobsComponent.fees.label': 'Fees',
  'userJobsComponent.job_fee_id.validationMessage':
    '求人タイプを選択してください',
  'userJobsComponent.job_fee_id.placeholder': '求人タイプを選択',
  'userJobsComponent.months.validationMessage':
    '勤務期間（月数）を入力してください',
  'userJobsComponent.months.placeholder': '勤務期間（月数）を入力してください',
  'userJobsComponent.employer.validationMessage':
    'Employer should not be empty',
  //'userJobsComponent.employer.placeholder': (title) =>
  // `あなたの${title}を入力してください`,
  'userJobsComponent.position.validationMessage':
    'Position should not be empty',
  //'userJobsComponent.position.placeholder': (title) =>
  //`あなたの${title}を入力してください`,
  'userJobsComponent.job_fee_id.placeholder': 'Select job type',
  'userJobsComponent.job_fee_id.validationMessage':
    'Job fee type should not be empty',
  'userJobsComponent.months.validationMessage':
    '勤務期間（月数）を入力してください',
  'userJobsComponent.months.placeholder': 'Duration of Job Post (in months)',

  //Jobs Cart
  'userJobsCartComponent.heading': 'Jobs Payment Method',
  'userJobsCartComponent.subheading':
    'Get Details about jobs payment price , schedule & more...',

  //Common Payment Checkout Form
  'specialPaymentFormComponent.payWithCreditCard':
    'カードまたはデジタルウォレットで支払う',
  'specialPaymentFormComponent.payWithApplePay': 'Pay with Apple Pay',
  'specialPaymentFormComponent.creditCardProcessingFeeNotice':
    '小規模予算で運営している非営利団体として、可能な限り運営コストの削減に努めています。カードおよびデジタルウォレット決済には2.9%以上の手数料がかかり、年間でかなりの金額になります。手数料の一部をご負担いただけますと幸いです。なお、この手数料を避けたい場合は、当方の手数料がより少ない銀行関連の決済方法をご選択いただけます。',
  'specialPaymentFormComponent.applePayProcessingFeeNotice':
    '小規模予算で運営している非営利団体として、可能な限り運営コストの削減に努めています。Apple Pay決済には2.9%以上の手数料がかかり、年間でかなりの金額になります。手数料の一部をご負担いただけますと幸いです。なお、この手数料を避けたい場合は、当方の手数料がより少ない銀行振込をご選択いただけます。',
  'specialPaymentFormComponent.confirmAndPay': 'Confirm & Pay',
  'specialPaymentFormComponent.confirmAndPay.japanese': '確認して支払う',
  'specialPaymentFormComponent.confirmAndPay.english': 'Confirm & Pay',
  'userAttendeeCartComponent.credit.coverProcessingFeeBeforeAmount':
    '決済処理手数料（2.9%）',
  'userAttendeeCartComponent.applePay.coverProcessingFeeBeforeAmount':
    'Apple Pay決済手数料（2.9%）',
  'userAttendeeCartComponent.credit.coverProcessingFeeAfterAmount':
    'を負担します。この手数料は返金対象外です。',

  //Common Ads Listing Card
  'userCommonAdsListingCard.button.pay': 'Pay',
  'userCommonAdsListingCard.button.edit': 'Edit',
  'userCommonAdsListingCard.button.checkItOut': 'Check It Out',

  //Ads Cart
  'adsComponent.cart.payment.vendor': 'Vendor Name',
  'adsComponent.cart.payment.description': 'Description',
  'adsComponent.cart.payment.adType': 'Ad Type',
  'adsComponent.cart.payment.months': 'Ad Months',
  'adsComponent.cart.payment.fees': 'Fees',

  //Common Hero Text
  'commonHeroText.availableCredit': '利用可能なクレジット',

  //My Event Listing To Be Paid
  'myEventListingToBePaid.placeHolder': 'イベント名で検索',

  //My Event Card
  'myEventCard.registrationClosed':
    '申し訳ございませんが、このイベントへの登録は終了いたしました。順番待ちリストに追加されます。',
  'myEventCard.pleaseSelectAttendee': '参加者を選択してください',
  'myEventCard.askForRefund': '払い戻しを依頼する',
  'myEventCard.editRegistration': '登録を編集',
  'myEventCard.completePayment': '支払い完了',

  //Event Details Modal
  'userEventDetailsModal.refundMode.pbssCredit': 'PBSSクレジット',
  'userEventDetailsModal.refundMode.refundToBank': '銀行に返金',
  'userEventDetailsModal.name': '名前',
  'userEventDetailsModal.email': 'メール',
  'userEventDetailsModal.registrationType': '登録タイプ',
  'userEventDetailsModal.companyAffiliation': '会社/所属',
  'userEventDetailsModal.department': '部門・部署名',
  'userEventDetailsModal.jobTitle': 'タイトル',
  'userEventDetailsModal.refundedAmount': '返金額',
  'userEventDetailsModal.refundType': '払い戻しの種類',
  'userEventDetailsModal.registrationStatus': '登録ステータス',
  'userEventDetailsModal.paid': '支払済',
  'userEventDetailsModal.paymentConfirmed': '支払いが確認されました',
  'userEventDetailsModal.feeWaiver': '手数料免除',
  'userEventDetailsModal.registrationCancelled': '登録がキャンセルされました',
  'userEventDetailsModal.paymentRefunded': '支払いが返金されました',
  'userEventDetailsModal.refundPending': '返金保留中',
  'userEventDetailsModal.noChargeEvent': '無課金イベント',
  'userEventDetailsModal.paymentProcessing': '支払い処理中',
  'userEventDetailsModal.toBePaid': '支払い予定',
  'userEventDetailsModal.attendanceType': '出席タイプ',
  'userEventDetailsModal.cost': '支払額',
  'userEventDetailsModal.modeOfRefund': '返金方法',
  'userEventDetailsModal.totalCost': '支払額',
  'userEventDetailsModal.paymentDate': '支払日',
  'userEventDetailsModal.processingFee': '処理手数料 (2.9%)',
  'userEventDetailsModal.processingFeeTooltip':
    'この処理手数料は返金されません。',
  'userEventDetailsModal.askForRefund': '払い戻しを依頼する',
  'userEventDetailsModal.payment': '支払い',
  'userEventDetailsModal.sponsorshipType': 'スポンサーシップタイプ',
  'userEventDetailsModal.date': '日付',

  //My Event Listing To Be Paid
  'myEventListingToBePaid.noEventsAvailable': '利用可能なイベントはありません',

  //My Event Card
  'myEventCard.refund': '返金',
  'myEventCard.selectAttendeeForRefund': '払い戻し対象者を選択',
  'myEventCard.cancelRegistration': '登録をキャンセル',
  'myEventCard.selectAttendeeForCancellation': 'キャンセル対象者を選択',

  //My Event Listing
  'myEventListing.pageName': '私のイベント',
  'myEventListing.status': '状態',
  'myEventListing.searchPlaceholder': 'イベント名で検索',
  'myEventListing.noWaitingListAvailable': '待機リストはありません',
  'myEventListing.noEventsAvailable': '利用可能なイベントはありません',

  //EventType Filter
  'eventTypeFilter.regularRegistration': '通常登録',
  'eventTypeFilter.sponsorshipRegistration': 'スポンサー登録',
  'eventTypeFilter.waitingListRegistration': '待機リスト登録',

  //Receipt Component
  'receiptComponent.registrationReceipt': '登録受領書',
  'receiptComponent.adReceipt': '広告領収書',
  'receiptComponent.jobReceipt': '求人領収書',
  'receiptComponent.eventName': 'イベント名',
  'receiptComponent.logoText': 'Pharmaceutical & BioScience Society',
  'receiptComponent.location': '場所',
  'receiptComponent.eventType': 'イベントタイプ',
  'receiptComponent.name': '名前',
  'receiptComponent.email': 'メール',
  'receiptComponent.company': '会社',
  'receiptComponent.department': '部署',
  'receiptComponent.jobTitle': '職種',
  'receiptComponent.vendor': 'ベンダー',
  'receiptComponent.employer': '雇用主',
  'receiptComponent.position': '職位',
  'receiptComponent.positionDesignation': '職位 / 役職',
  'receiptComponent.contactInfo': '連絡先情報',
  'receiptComponent.attachmentUrl': '添付URL',
  'receiptComponent.adType': '広告タイプ',
  'receiptComponent.jobType': '求人タイプ',
  'receiptComponent.months': '期間（月）',
  'receiptComponent.listingPeriod': '掲載期間',
  'receiptComponent.jobNotApprovedYet': '求人はまだ承認されていません',
  'receiptComponent.adNotApprovedYet': '広告はまだ承認されていません',
  'receiptComponent.description': '説明',
  'receiptComponent.requirement': '要件',
  'receiptComponent.advertiserName': '広告主名',
  'receiptComponent.totalPrice': '合計金額',
  'receiptComponent.transactionId': '取引ID',
  'receiptComponent.refundedAmount': '返金額',
  'receiptComponent.refundType': '払い戻しの種類',
  'receiptComponent.registrationOptions': '登録オプション',
  'receiptComponent.foodOptions': '食事のオプション',
  'receiptComponent.attendanceType': '出席タイプ',
  'receiptComponent.totalCost': '支払額',
  'receiptComponent.paymentDetails': '支払い詳細',
  'receiptComponent.price': '費用',
  'receiptComponent.downloading': 'ダウンロード中...',
  'receiptComponent.downloadReceipt': '領収書をダウンロード',
  'receiptComponent.localChapterName': 'チャプター名',
  'receiptComponent.discount': '割引',
  'receiptComponent.processingFee': '処理手数料 (2.9%)',
  'receiptComponent.processingFeeTooltip': 'この処理手数料は返金されません。',
  'receiptComponent.processingFeeNote': '注: 処理手数料は返金されません。',
  'receiptComponent.total': '支払額',
  'receiptComponent.date': '日付',
  'receiptComponent.paymentDate': '支払日',
  'receiptComponent.cardLast4': 'クレジットカード番号',
  'receiptComponent.status': '登録ステータス',

  //Add Attendee Component
  'addAttendeeComponent.table.title.name': '名前',
  'addAttendeeComponent.table.title.email': 'メール',
  'addAttendeeComponent.table.title.option': 'オプション',
  'addAttendeeComponent.table.title.company': '会社/所属',
  'addAttendeeComponent.table.title.price': '費用​',
  'addAttendeeComponent.table.title.attendanceType': '出席タイプ',
  'addAttendeeComponent.table.title.action': 'アクション',
  'addAttendeeComponent.confirmationAction.heading': 'お支払い合計金額',
  'addAttendeeComponent.confirmationAction.submitName': '続行',

  //Sponsorship Option Component
  'sponsorshipOptionComponent.heading': 'スポンサーシップのオプション',
  'sponsorshipOptionComponent.alertMessage':
    'このイベントにはスポンサーオプションはありません。',
  'sponsorshipOptionComponent.goBackToAttendeeRegistration': '参加者登録に戻る',
  'sponsorshipOptionComponent.sponsorPerksListing.heading': 'スポンサー特典',
  'sponsorshipOptionComponent.sponsorPerksListing.description':
    'スポンサーシップのオプション、スケジュールなどの詳細をご覧ください...',
  'sponsorshipOptionComponent.sponsorPerksListing.contactUs': 'お問い合わせ',
  'sponsorshipOptionComponent.sponsorPerksListing.contactUs.link':
    'info.japan@pbss.org',
  'sponsorshipOptionComponent.sponsorPerksListing.contactUs.description':
    '登録に関してご質問や問題が発生した場合。',

  //Sponsor Perks Component
  'sponsorPerksComponent.sponsorPerks.spot': '残り{{spot}}枠',
  'sponsorPerksComponent.sponsorPerks.uploadLogo':
    '企業/スポンサーロゴをアップロード',

  //Sponsor Add Component

  'sponsorAddComponent.table.title.name': '名前',
  'sponsorAddComponent.table.title.email': 'メール',
  'sponsorAddComponent.table.title.option': 'オプション',
  'sponsorAddComponent.table.title.company': '会社/所属',
  'sponsorAddComponent.table.title.price': '価格',
  'sponsorAddComponent.table.title.attendanceType': '出席タイプ',
  'sponsorAddComponent.table.title.action': 'アクション',
  'sponsorAddComponent.confirmationAction.heading': 'お支払い合計金額',
  'sponsorAddComponent.confirmationAction.submitName': '確認に進む',
  'sponsorAddComponent.errorMessage':
    'まずスポンサーの詳細を保存してください。',
  'sponsorAddComponent.fileFormatError':
    '受け入れ可能なファイル形式: PDF、JPG、PNG のみ',
  'sponsorAddComponent.fileSizeError': (size) =>
    `ファイルは${size}MB未満にしてください。`,
  'sponsorAddComponent.imageSizeError':
    '画像サイズは 200x200 ピクセルより大きくなければなりません。',
  'sponsorAddComponent.contactUs': 'お問い合わせ  ',
  'sponsorAddComponent.contactUs.link': 'info.japan@pbss.org',

  //Sponsor Detail Form
  'sponsorDetailForm.contactPersonFirstName': '連絡先担当者名（名）',
  'sponsorDetailForm.contactPersonLastName': '連絡先担当者名（姓）',
  'sponsorDetailForm.contactPersonEmail': '連絡先メールアドレス',
  'sponsorDetailForm.companyAffiliation': '会社/所属',
  'sponsorDetailForm.action': 'アクション',

  //Editable Cell
  'editableCell.emailAlreadyExists':
    '参加者のメール アドレスは既に存在します。',
  'editableCell.quantityExhausted':
    'このオプションの数量は完売しました（待機リストに参加するには、新規登録を行ってください）。',
  'editableCell.limitExhausted': 'このオプションの制限に達しました。',
  'editableCell.inPersonFull':
    '対面参加は満席です。ウェイトリストに追加されます。',
  'editableCell.workshopPresentationFull':
    'ワークショップ発表の席は満席です。',
  'editableCell.waitingList':
    '「この登録オプションは現在満席です。カートに追加して待機リストに参加し、空席が出たら通知を受け取ってください。」',
  'editableCell.pleaseFillOutFirstName': '名前を入力してください',
  'editableCell.enterAttendeeFirstName': '参加者の名を入力してください​',
  'editableCell.pleaseFillOutLastName': '姓を入力してください',
  'editableCell.enterAttendeeLastName': '参加者の姓を入力してください',
  'editableCell.inPerson': '対面',
  'editableCell.webcast': 'ウェブキャスト',
  'editableCell.forNonLocalsOnly': '遠方の方のみ',
  'editableCell.pleaseEnterValidEmail':
    '有効なメールアドレスを入力してください',
  'editableCell.pleaseFillOut': (title) => `${title}を入力してください`,
  'editableCell.confirm': (title) => `${title}を確認してください`,
  'editableCell.confirmAttendee': (title) =>
    `参加者の${title}を確認してください`,
  'editableCell.enter': (title) => `${title}を入力してください`,
  'editableCell.enterAttendee': (title) => `参加者の${title}を入力してください`,
  'editableCell.pleaseSelectRegistrationOption':
    '参加者登録オプションを選択してください',
  'editableCell.pleaseSelectFoodOption':
    '参加者の食事オプションを選択してください',
  'editableCell.selectAttendeeFoodOption': '参加者の食事オプションを選択',
  'editableCell.emailIdsMustMatch': 'メールIDは一致する必要があります',
  'editableCell.firstName': '名',
  'editableCell.lastName': '姓',
  'editableCell.pleaseConfirm': (title) => `${title}を確認してください`,
  'editableCell.selectAttendeeRegistrationOption': '参加者登録オプションを選択',
  'editableCell.departmentDivision': '部門・部署名',
  'editableCell.jobTitleRole': 'タイトル',
  'editableCell.enterAttendeeDepartmentDivision':
    '部門・部署名を入力してください',
  'editableCell.enterAttendeeJobTitleRole': 'タイトル・ポジションを入力してください',
  'editableCell.enterCompanyAffiliation': '参加者の会社/所属を入力してください',


  //Sponsor Modal
  'sponsorModal.assetDetails': '資産の詳細',
  'sponsorModal.uploadFlyer': 'チラシをアップロード',
  'sponsorModal.acceptsOnly':
    'PDF/画像ファイル（png、jpg、jpeg、pdf）のみ受け入れます',
  'sponsorModal.maximumFileSize': (size) =>
    `最大ファイルサイズは${size}MBです。`,
  'sponsorModal.acceptsOnlyImage':
    '画像ファイル（png、jpg、jpeg）のみ受け入れます。',
  'sponsorModal.uploadCompanyLogo': '企業/スポンサーロゴをアップロード',
  'sponsorModal.uploadedLogos': 'アップロードされたロゴ',
  'sponsorModal.uploadedFlyer': 'アップロードされたチラシ',
  'sponsorModal.back': '戻る',
  'sponsorModal.submit': '提出する',

  //Event Common Table
  'eventCommonTable.name': '名前',
  'eventCommonTable.email': 'メール',
  'eventCommonTable.lunch': 'ランチ',
  'eventCommonTable.company': '会社/所属',
  'eventCommonTable.price': '価格',
  'eventCommonTable.action': 'アクション',
  'eventCommonTable.deleteText': '消去',
  'eventCommonTable.editText': '編集',
  'eventCommonTable.meetingPresentation.title':
    '会議プレゼンテーションへの出席',
  'eventCommonTable.meetingPresentation.price': (price) =>
    `会議プレゼンテーションへの出席 $${price}?`,
  'eventCommonTable.dinner.title': '夕食会に出席する',
  'eventCommonTable.dinner.price': (price) => `夕食会に出席する $${price}?`,
  'eventCommonTable.company': '会社/所属',
  'eventCommonTable.price': '費用​',

  //Sponsor Editable Cell
  'sponsorEditableCell.emailAlreadyExists':
    '既に参加者のメールアドレスとして存在します！',
  'sponsorEditableCell.pleaseEnterValidEmailAddress':
    '有効なメールアドレスを入力してください',
  'sponsorEditableCell.pleaseConfirmAttendee': (title) =>
    `参加者の${title}を確認してください`,
  'sponsorEditableCell.enterAttendee': (title) =>
    `参加者の${title}を入力してください`,
  'sponsorEditableCell.pleaseSelectAttendeeLunchOption':
    '参加者の昼食オプションを選択してください',
  'sponsorEditableCell.selectAttendeeLunchOption':
    '参加者の昼食オプションを選択',
  'sponsorEditableCell.pleaseFillOut': (title) =>
    `参加者の${title}を入力してください`,
  'sponsorEditableCell.confirm': (title) =>
    `参加者の${title}を確認してください`,
  'sponsorEditableCell.confirmAttendee': (title) =>
    `参加者の${title}を確認してください`,
  'sponsorEditableCell.enter': (title) => `参加者の${title}を入力してください`,
  'sponsorEditableCell.enterAttendee': (title) =>
    `参加者の${title}を入力してください`,
  'sponsorEditableCell.pleaseSelectRegistrationOption':
    '参加者登録オプションを選択してください',
  'sponsorEditableCell.pleaseSelectFoodOption':
    '参加者の食事オプションを選択してください',
  'sponsorEditableCell.selectAttendeeFoodOption':
    '参加者の食事オプションを選択',
  'sponsorEditableCell.emailIdsMustMatch': 'メールアドレスが一致しません',
  'sponsorEditableCell.firstName': '名',
  'sponsorEditableCell.lastName': '姓',
  'sponsorEditableCell.pleaseConfirm': (title) =>
    `参加者の${title}を確認してください`,
  'sponsorEditableCell.pleaseFillOutFirstName': '名前を入力してください',
  'sponsorEditableCell.enterAttendeeFirstName': '参加者の名を入力してください​',
  'sponsorEditableCell.pleaseFillOutLastName': '姓を入力してください',
  'sponsorEditableCell.enterAttendeeLastName': '参加者の姓を入力してください',

  //Payment Success
  'paymentSuccess.thankYou': `
    ご登録ありがとうございます。確認メールがまもなく届きます。
  `,
  'paymentSuccess.registrationCompleted': '登録完了',
  'paymentSuccess.thankYou2': `
    お支払いが正常に処理されました。ご購入いただきありがとうございます。
                確認メールがすぐに届きます。
  `,
  'paymentSuccess.adsTitle': 'お支払いを受け付けました。',
  'paymentSuccess.adsSubTitle':
    '広告は管理者による審査・承認後、まもなく掲載されます。',
  'paymentSuccess.jobsTitle': '情報を受け付けました。',
  'paymentSuccess.jobsSubTitle':
    '求人広告は管理者による審査・承認後、まもなく掲載されます。',
  'paymentSuccess.title': '支払いが完了しました！',
  'paymentSuccess.backToHome': 'ホームへ戻る​',
  'paymentSuccess.goToAds': '広告へ移動',
  'paymentSuccess.goToJobs': '求人情報へ',
  'paymentSuccess.goToMyEvents': 'マイイベントへ移動',
  'paymentSuccess.goToPaymentProcessing': 'マイカートへ移動',

  //Common Modal
  'commonModal.cancel': 'キャンセル',

  //Payment Checkout Form
  'paymentCheckoutComponent.backToCart': 'カートに戻る',
  'paymentCheckoutComponent.backToAddAttendees': '参加者追加に戻る',
  'paymentCheckoutComponent.registrationSummary.heading': '登録内容の確認',
  'paymentCheckoutComponent.registrationSummary.couponApplied':
    '適用済みクーポン',
  'paymentCheckoutComponent.registrationSummary.vendorReps':
    'ベンダー担当者',
  'paymentCheckoutComponent.registrationSummary.sponsorshipOption':
    'スポンサーシップオプション',

  //Chapter Page
  'chapterPage.sponsorshipDetails.title': 'スポンサーシップの詳細',
  'chapterPage.contactUs.title': 'お問い合わせ',
  'chapterPage.mission.title': '私たちの使命',
  'chapterPage.chapterHeading.title': 'リーダーシップチーム',
  'chapterPage.chapterHeading.subtitle':
    'メンバー名をクリックするとプロフィールが表示されます',

  'mainLayoutComponent.navbar.login': 'ログイン',
  'mainLayoutComponent.navbar.join': 'PBSSに参加する',
  'mainLayoutComponent.navbar.logout': 'ログアウト',

  //Register Component
  'userRegisterComponent.contactUs':
    '登録に関してご質問や問題が発生した場合、お問い合わせは',
  'userRegisterComponent.contactUsMessage': 'にご連絡ください。​',

  'userRegisterComponent.firstName': '名',
  'userRegisterComponent.lastName': '姓',
  'userRegisterComponent.email': 'メール',
  'userRegisterComponent.confirmEmail': 'メール（確認用）​',
  'userRegisterComponent.password': 'パスワード',
  'userRegisterComponent.confirmPassword': 'パスワード（確認用）',
  'userRegisterComponent.address': '住所',
  'userRegisterComponent.addressLine1': '住所1',
  'userRegisterComponent.addressLine2': '住所2',
  'userRegisterComponent.cityTown': '市区町村',
  'userRegisterComponent.stateProvinceRegion': '都道府県',
  'userRegisterComponent.zipPostalCode': '郵便番号',
  'userRegisterComponent.country': '国',
  'userRegisterComponent.companyName': '会社、機関名等',
  'userRegisterComponent.contactNumber': '+19898989898',
  'userRegisterComponent.contactNumber.title': '電話番号​',
  'userRegisterComponent.localChapter': 'Chapterを選択ください',
  'userRegisterComponent.selectChapter.title':
    '通知を受け取りたい追加のChapterを選択ください',
  'userRegisterComponent.selectChapter':
    '通知を受け取りたい追加のChapterを選択ください',
  'userRegisterComponent.selectArea': '関心のある分野を選択​',
  'userRegisterComponent.addOtherInterests': 'その他の関心のある分野を追加​',
  'userRegisterComponent.enterAreas':
    '関心のある分野をコンマで区切って入力してください',
  'userRegisterComponent.vendorRepresentative': '私はベンダー担当者です',
  'userRegisterComponent.iAcceptTermsAndConditions':
    '続行すると、当社の利用規約および日本支部イベント規約に同意したことになります。',
  'userRegisterComponent.iAcceptTermsAndConditions.title1': '続行すると、',
  'userRegisterComponent.iAcceptTermsAndConditions.title2':
    '当団体の利用規約および日本支部プライバシーポリシー',
  'userRegisterComponent.iAcceptTermsAndConditions.title3':
    'に同意したことになります。',
  'userRegisterComponent.captcha': '上記のCAPTCHAをクリックしてください',
  'userRegisterComponent.register': 'PBSS利用規約に同意して登録',
  'userRegisterComponent.cancel': 'キャンセル',
  'userRegisterComponent.companyNameLabel': '会社／組織',
  'userRegisterComponent.jobTitle.label': '役職',
  'userRegisterComponent.jobTitle.placeholder': '役職、または N/A を入力してください',
  'userRegisterComponent.jobTitle.helpText':
    '現在、役職がない場合は N/A と入力してください。',
  'userRegisterComponent.jobTitle.required': '役職を入力してください',
  'userRegistrationComponent.successMessage':
    'アカウントが正常に作成されました。」.​',

  //Login Component
  'userLoginComponent.email': 'メールアドレス​',
  'userLoginComponent.password': 'パスワード',
  'userLoginComponent.password.validation': 'パスワードを入力してください',
  'userLoginComponent.notAMember': '会員登録がお済みでない場合​',
  'userLoginComponent.createAccount':
    '無料アカウントを作成するにはここをクリックしてください',
  'userLoginComponent.forgotPassword': 'パスワードを忘れた場合',
  'userLoginComponent.completeCaptcha': '上記のCAPTCHAをクリックしてください',
  'userLoginComponent.login': 'ログイン',
  'userLoginComponent.popup.heading': '利用規約',
  'userLoginComponent.popup.subheading':
    '続行すると、当社の利用規約および日本支部イベント規約に同意したことになります。',
  'userLoginComponent.popup.button.viewTerms&Conditions': '利用規約を見る',
  'userLoginComponent.popup.button.accept': '受け入れる',
  'userLoginComponent.popup.button.accepting': '受け入れ中...',

  //User Update Profile Component
  'userUpdateProfileComponent.update_profile_success':
    'プロフィールが正常に更新されました！',

  //Event Card
  'eventCard.registrationClosed': '登録は終了しました',
  'eventCard.details': '詳細',
  'eventCard.speakers': '講演者',
  'eventCard.organizers': '主催者',
  'eventCard.registrationFee': '登録料',
  'eventCard.location': '場所',
  'eventCard.sponsors': 'スポンサー',
  'eventCard.exhibitors': '展示会',
  'eventCard.webcastForNonLocalAttendees':
    'タイトル: 遠方の参加者向けのウェブキャスト',
  'eventCard.registerNow': '今すぐ登録',
  'eventCard.cta.registrationClosed': '登録は終了しました',
  'eventCard.sponsorshipAvailable': 'スポンサーシップあり',
  'eventCard.registrationClosesOn': '登録締め切り',
  'eventCard.otherSponsorshipOpportunitiesOpen': 'その他のスポンサー枠受付中',
  'eventCard.sponsorshipOpportunitiesOpen': 'スポンサー枠受付中',
  'eventCard.vendorShowExhibitorOpportunitiesOpen':
    'ベンダーショー出展枠受付中',
  'eventCard.sponsorshipAtCapacity': '—',
  'eventCard.vendorShowAtCapacity': '—',

  //Add Attendees Component
  'addAttendeesComponent.label.noFoodOption': '食事なし',
  'userAddAttendeeComponent.coupancodeinput.placeholder':
    'クーポンコードを入力してください​',
  'userAddAttendeeComponent.eventSponsor.limitof': '上限',
  'userAddAttendeeComponent.eventComanTable.free': '無料',
  'userAddAttendeeComponent.faq': 'よくある質問',
  'userAddAttendeeComponent.eventRegistrationModel.n/a': '該当なし',

  //Stay Tuned Component
  'stayTunedComponent.title': 'さらなる情報をお楽しみに！',
  'stayTunedComponent.backHome': 'ホームに戻る',

  //Other Partners Component
  'otherPartnersComponent.title': 'PBSSのパートナー組織',

  //Career Mentorship Component
  'careerMentorshipComponent.title': 'キャリアメンターシップ',

  //Jobs Component
  'userJobsComponent.alert.title': 'No Jobs Available',

  //Text Editor
  'textEditor.enter': 'Enter',
  'textEditor.here': 'here',
  'textEditor.yourDetails': 'あなたの詳細',

  //Footer
  'footer.links.title': 'Links',
  'footer.events.title': 'Events',

  //Event Details Component
  'eventDetailsComponent.viewFlyer': 'チラシを見る',
  'eventDetailsComponent.eventFlyerImages': 'イベントチラシ画像',

  'adminActionsDropdownComponent.saveText': '保存',
  'adminActionsDropdownComponent.cancelText': 'キャンセル',
  'adminActionsDropdownComponent.copyText': 'コピー',
  'adminActionsDropdownComponent.deleteText': '削除',
  'adminActionsDropdownComponent.editText': '編集',

  'adminActionsDropdownComponent.viewText': '表示',
  'adminActionsDropdownComponent.deleteConfirmTitle': (text) =>
    `削除の確認 ${text}`,
  'adminActionsDropdownComponent.deleteConfirmDescription':
    '本当に削除してもよろしいですか？',
  'adminActionsDropdownComponent.deleteConfirmOkText': 'はい',
  'adminActionsDropdownComponent.deleteConfirmCancelText': 'いいえ',

  'adminActionsDropdownComponent.toolTipTitle': '参加者',
  'majorSponsorListing.title': '主要スポンサー',

  'resetPassword.title': 'パスワードリセット',
  'resetPassword.successTitle':
    '成功！パスワードリセット用メールを送信しました',
  'resetPassword.successSubTitle':
    'お客様のアカウントに登録されているメールアドレス宛に、パスワードリセット用のメールを送信いたしました。受信トレイをご確認の上、記載された手順に従ってパスワードをリセットしてください。数分以内にメールが届かない場合は、迷惑メールフォルダもご確認ください。それでもメールが届かない場合は、サポートチームまでご連絡ください。弊社サービスをご利用いただきありがとうございます。',
  'resetPassword.goToLogin': 'ログインページへ',
  'resetPassword.resendEmail': 'メールを再送する',
  'resetPassword.heading': 'パスワードをリセットする​',
  'resetPassword.subheading':
    '下記にメールアドレスを入力してください。パスワードをリセットするためのリンクをお送りします。',
  'resetPassword.email': 'メールアドレス​',
  'resetPassword.submit': 'リセットリンクを送信',
  'resetPassword.emailRequired': '有効なメールアドレスを入力してください',
  'resetPassword.emailLabel': 'メールアドレス',
  'resetPassword.forgotPassword': 'パスワードをお忘れですか?​',
  'resetPassword.enterEmail': 'メールアドレスを入力してください',
  'resetPassword.backToSignIn': 'サインインに戻る',
  'resetPassword.resetButtonText': 'パスワードリセット',
  waitingListAttendees: '待ち行列参加者',
  'waitingList.firstName': '氏名',
  'waitingList.memberName': '会員名',
  'waitingList.memberEmail': '会員メール',
  'waitingList.email': 'メール',
  'waitingList.registrationType': '登録タイプ',
  'waitingList.registrationType.workshop': 'ワークショップ',
  'waitingList.optionType': 'オプションタイプ',
  'waitingList.optionType.registration': '登録',
  'waitingList.optionType.sponsorship': 'スポンサーシップ',
  'waitingList.attendeeType': '参加者タイプ',
  'waitingList.attendeeType.regular': '通常',
  'waitingList.eventOption': 'イベントオプション',
  'waitingList.attendanceType': '参加形式',
  'waitingList.attendanceType.inPerson': '対面',
  'waitingList.attendanceType.webcast': 'ウェブキャスト',
  'waitingList.sponsorshipType': 'スポンサーシップタイプ',
  'waitingList.date': '日付',
  'waitingList.localChapter': 'ローカルチャプター',
  'waitingList.attendeeAdded': '参加者追加済み',
  'waitingList.attendeeAddedShort': '追加',
  'waitingList.actions': '操作',
  'waitingList.moveToRegistration': 'イベント登録へ移動',
  'waitingList.moveToRegistration.confirmTitle': 'イベント登録へ移動',
  'waitingList.moveToRegistration.confirmDescription':
    'イベントオプションの定員を増やし、この参加者の「未払い」登録を作成し、待機リストで登録済みとしてマークします。続行しますか？',
  'waitingList.moveToRegistration.success':
    '参加者をイベント登録に移動しました。',
  'waitingList.cancelled': 'キャンセル済み',
  'waitingList.cancelEntry': 'エントリーをキャンセル',
  'waitingList.cancelEntry.confirmTitle': '待機リストエントリーをキャンセル',
  'waitingList.cancelEntry.confirmDescription':
    'この参加者をアクティブな待機リストから削除します。アカウント側では表示されなくなります。続行しますか？',
  'waitingList.cancelEntry.success': '待機リストエントリーをキャンセルしました。',
  'pbss.generalInformation.subtitle':
    'これはPBSSインターナショナルの一般情報です。支部固有の情報については、各支部にお問い合わせください。',
  //Register Form
  'userRegisterComponent.captcha.title': 'CAPTCHAを入力してください',
  'userRegisterComponent.emailValidation':
    '有効なメールアドレスを入力してください',
  'userRegisterComponent.addNote':
    '転職によるログインの問題を回避するために、仕事用メール アドレスではなく、永続的な個人用メール アドレスを使用することを強くお勧めします。',
  'userRegisterComponent.passwordValidation':
    'パスワードは8文字以上である必要があります',
  'userRegisterComponent.passwordSpaceValidation':
    'パスワードにはスペースを含めることはできません。',
  'userRegisterComponent.passwordEmptyValidation':
    'パスワードは空欄にできません。',
  'userRegisterComponent.firstNameValidation':
    '名には数字は使用できません。255文字未満で入力してください。​',
  'userRegisterComponent.lastNameValidation':
    '姓には数字は使用できません。255文字未満で入力してください。',
  'userRegisterComponent.cityValidation':
    '市区町村名は英字のみ使用でき、255文字未満で入力してください。',
  'userRegisterComponent.contactNumberValidation':
    '' +
    'で始まり、その後に国番号が続く、10桁以上13桁以下の有効な電話番号を入力してください。',
  'userRegisterComponent.address1Validation':
    '住所行 1 の先頭にはスペースを含めることはできません。また、255 文字以下にする必要があります',
  'userRegisterComponent.address2Validation':
    '住所行 2 の先頭にはスペースを含めることはできません。また、255 文字以下にする必要があります',
  'userRegisterComponent.zipCodeValidation':
    '郵便番号は先頭にスペースを含めることはできません。また、255 文字以下にする必要があります。',
  'userRegisterComponent.zipCodeRequired': '郵便番号を入力してください',
  'userRegisterComponent.stateRequired': '都道府県を選択してください',
  'userRegisterComponent.companyNameValidation':
    '会社名は 255 文字未満にしてください。',
  'userRegisterComponent.jobTitleValidation':
    '役職は先頭にスペースを含めることはできません。また、255 文字以下にする必要があります。',

  'userAddAttendeeComponent.messageForWebcast.question':
    'ウェブキャストの自己負担率が対面参加の自己負担率よりも高いのはなぜですか?',

  'userAddAttendeeComponent.messageForWebcast.answer1':
    '対面で参加される場合の自己負担料金は、ネットワーキングやビジネス開発のために参加者と直接会うことを熱望するスポンサーや出展者によって大幅に補助されています。ウェブキャストにはスポンサーがないため、同じ低価格の補助金付き料金をご提供することはできませんが、それでも自己負担料金は通常料金より最大60%割引となります。',

  'userAddAttendeeComponent.messageForWebcast.answer2':
    'また、ウェブキャストには他支部からの参加者が集まるため、これらの参加者は地元支部で開催される同じテーマの対面イベントには参加しないということが判明しました。その結果、対面参加者が減少し、スポンサーも減少し、最終的には参加者の費用が増加し、組織の長期的な存続と地域社会への優れたサービス提供が危うくなっています。',

  'userAddAttendeeComponent.messageForWebcast.answer3':
    '私たちは非営利団体であるため、リソースが限られており、厳しい予算と増加する経費を動的に管理する必要があります。経費を最小限に抑え、皆様にとっての価値を最大化するために、私たちはあらゆる努力を尽くしておりますので、ご安心ください',

  'userAddAttendeeComponent.messageForWebcast.answer4':
    'いくつかのオプションがあります: 1) PBSS 支部から 2 時間以上かかる場合でも、対面での自己負担料金と同じ料金でウェブキャストに参加できます。2) 後ほど地元支部で開催されるこのトピックのイベントに参加するまでお待ちください。このイベントでも、約 85% の割引が適用されます。3) 今すぐウェブキャストに参加し、支部で今後開催される対応する対面イベントの無料パスを受け取ってください。',

  // Vendor reps on a paid sponsorship (My Events)
  'sponsorshipReps.sponsor': 'スポンサー',
  'sponsorshipReps.contact': '担当者',
  'sponsorshipReps.freeRepsUsed': '無料ベンダー担当者の利用数',
  'sponsorshipReps.addReps': 'ベンダーショー出席者を追加',
  'sponsorshipReps.editReps': 'ベンダーショー出席者を編集',
  'sponsorshipReps.editRep': '編集',
  'sponsorshipReps.actions': '操作',
  'sponsorshipReps.originalPurchase': 'スポンサーシップ購入',
  'sponsorshipReps.addedReps': '追加したベンダーショー出席',
  'sponsorshipReps.payment': '支払い',
  'sponsorshipReps.limitReachedAll':
    'このスポンサーシップの無料ベンダー担当者とスポンサー特典の出席枠はすべて使用されています。',
  'sponsorshipReps.changesClosed':
    'スポンサーシップ登録およびベンダー担当者の追加・編集はイベントの7日前まで可能です。それ以降の変更はPBSS管理者へ連絡するか、info@pbss.org までメールしてください。',
  'sponsorshipReps.limitReached':
    'このスポンサーシップの無料ベンダー担当者枠はすべて使用済みです。',
  'sponsorshipReps.payEachSponsorship':
    '複数のスポンサーシップに未払いのベンダー担当者がいます。それぞれのスポンサーシップを開き、担当者の支払いを別々に行ってください。',
  'sponsorshipReps.addRepsTitle': 'ベンダーショー出席者を追加',
  'sponsorshipReps.editRepTitle': 'ベンダーショー出席者を編集',
  'sponsorshipReps.remainingFreeReps': '残りの無料ベンダー担当者枠',
  'sponsorshipReps.addAnotherRep': '担当者をさらに追加',
  'sponsorshipReps.remove': '削除',
  'sponsorshipReps.rep': 'ベンダー担当者',
  'sponsorshipReps.firstName': '名',
  'sponsorshipReps.lastName': '姓',
  'sponsorshipReps.email': 'メールアドレス',
  'sponsorshipReps.company': '会社名',
  'sponsorshipReps.department': '部署',
  'sponsorshipReps.jobTitle': '役職',
  'sponsorshipReps.food': '昼食',
  'sponsorshipReps.noFood': '食事なし',
  'sponsorshipReps.discountedLunch': 'スポンサー割引昼食',
  'sponsorshipReps.attendPresentation': 'プレゼンテーションに参加',
  'sponsorshipReps.dinnerWithSpeakers': '講演者との夕食',
  'sponsorshipReps.freeLunch': '無料昼食',
  'sponsorshipReps.required': 'この項目は必須です',
  'sponsorshipReps.invalidEmail': '有効なメールアドレスを入力してください',
  'sponsorshipReps.continueToPayment': '次へ',
  'sponsorshipReps.save': '保存',
  'sponsorshipReps.cancel': 'キャンセル',
  'sponsorshipReps.paymentNote':
    '新しい担当者は、このスポンサーシップの別の支払いとして追加されます。確認メールは新しい担当者にのみ送信されます。',
  'sponsorshipReps.cancelCascadeNote':
    'スポンサーシップを返金またはキャンセルすると、すべてのベンダー担当者も返金またはキャンセルされます。',
  'sponsorshipReps.completeRepPayment': 'ベンダー担当者の支払いを完了',
  'addVendorReps.title': 'ベンダーショー出席者を追加',
  'addVendorReps.backToMyEvents': 'マイイベントに戻る',
  'addVendorReps.existingReps': 'このスポンサーシップのベンダー担当者',
  'addVendorReps.newReps': '新しいベンダー担当者を追加',
  'addVendorReps.addRep': 'ベンダー担当者を追加',
  'addVendorReps.noReps': 'この支払いにベンダー担当者はいません',
  'addVendorReps.totalToPay': 'お支払い合計',
  'addVendorReps.proceedToPayment': '支払いに進む',
  'addVendorReps.removeConfirm': 'このベンダー担当者を削除しますか？',
  'addVendorReps.yes': 'はい',
  'addVendorReps.no': 'いいえ',
};
